// Iran
const ACCESS_MESSAGE = "شما به این بخش دسترسی ندارید";
export const locale = {
  TRANSLATOR: {
    SELECT: "زبان خود را انتخاب کنید",
  },
  LAYOUT: {
    EXTRAS: {
      OFF_CANVAS: {
        QUICK_USER: {
          COMPANY: "شرکت",
          EDIT_USER: "ویرایش اطلاعات کاربر",
          EDIT_COMPANY: "ویرایش اطلاعات شرکت",
          LOGOUT: "خروج از سامانه",
        },
        QUICK_PANEL: {
          MESSAGES: "پیامها",
        },
      },
    },
    HEADER: {
      WALLET: {
        SMS_WALLET: "کیف پول پیامک",
        TOMAN: "تومان",
        CHARGE_WALLET: "افزایش موجودی کیف پول",
        UPDATE: "به‌ روزرسانی موجودی کیف پول",
      },
    },
  },
  COMPONENTS: {
    BASE: {
      EMERGENCY_LEVEL: {
        LEVEL1: "کم",
        LEVEL2: "متوسط",
        LEVEL3: "فوری",
        LEVEL4: "خیلی فوری",
      },
      SEND_GROUP_MESSAGE: {
        SELECTED_PEOPLE_TEXT: "افراد انتخاب شده برای ارسال پیام:",
        PERSON: "نفر",
        SELECT_PLACEHOLDER: "انتخاب الگوی پیام",
        SUBMIT_BTN_TEXT: "ارسال پیام",
        DESCRIPTION_PLACEHOLDER: "متن الگوی پیام",
        TITLE: "ارسال پیام",
      },
      DELETE_MODAL: {
        RETURN_BTN_TXT: "بازگشت",
        DELETE_BTN_TXT: "بله، حذف شود",
      },
      MULTI_SELECT: {
        SEARCH: "جستجو کنید",
        NO_DATA: "گزینه‌ای وجود ندارد",
        MORE_DATA: "مورد دیگر",
      },
      PROGRESS: {
        FROM: "از",
      },
      RESUME: {
        EDIT: "ویرایش",
        RESUME_EDIT: "ویرایش رزومه",
        ATTACHED_FILE: "فایل ضمیمه",
        DOWNLOAD_FILE: "دانلود فایل",
        SHOW_FILE: "نمایش فایل",
        DOWNLOAD: "دانلود",
        GENERAL_INFORMATION: "اطلاعات کلی",
        EDUCATIONAL_RECORD: "سوابق تحصیلی",
        JOB_EXPERIENCE: "سوابق شغلی",
        LAST_DEGREE: "آخرین مدرک تحصیلی",
        PHONE_NUMBER: "شماره تلفن ثابت",
        MILITARY: "وضعیت نظام وظیفه",
        INSERT_TIME: "تاریخ دریافت رزومه",
        BIRTH_DATE: "تاریخ تولد",
        CERTIFICATE_NUMBER: "شماره شناسنامه",
        CITIZENSHIP_ID: "شماره ملی",
        GENDER: "جنسیت",
        NUMBER_CHILDREN: "تعداد فرزندان",
        READY_TO_WORK: "آماده به کار در",
        POST_CODE: "کد پستی",
        MARITAL: "وضعیت تاهل",
        FATHER_NAME: "نام پدر",
        CITY_PROVINCE: "استان و شهر",
        BIRTH_PLACE: "محل تولد",
        PROPOSED_SALARY: "حقوق پیشهادی",
        LAST_JOB: "آخرین عنوان شغلی",
        GRADE: "مقطع تحصیلی",
        FIELD: "رشته تحصیلی",
        ORIENTATION: "گرایش",
        GPA: "معدل",
        TEACHER_NAME: "نام استاد راهنما",
        THESIS_TITLE: "عنوان پایان نامه",
        UNIVERSITY: "دانشگاه",
        STATUS: "وضعیت تحصیلی",
        WEB_SITE: "وب سایت",
        LEVEL: "سطح ارشدیت",
        SKILL_LEVEL: "سطح تسلط",
        TITLE: "عنوان",
        SKILLS: "مهارت‌ها",
        LANGUAGE: "زبان",
        LISTENING: "مهارت شنیدن",
        READING: "مهارت‌  خواندن",
        SPEAKING: "مهارت‌ گفتن",
        WRITING: "مهارت‌ نوشتن",
        EMPLOYER: "کارفرما",
        PROJECT_STATUS: "وضعیت پروژه",
        PROJECTS: "پروژه‌ها",
        HONORS: "افتخارات",
        HONOR_DATE: "تاریخ کسب",
        START_DATE: "تاریخ شروع",
        END_DATE: "تاریخ پایان",
        CONTACT: "راه‌های ارتباطی",
        TWITTER: "توییتر",
        INSTAGRAM: "اینستاگرام",
        LINKEDIN: "لینکدین",
        TELEGRAM: "تلگرام",
        GITHUB: "گیت هاب",
        STACK_OVERFLOW: "استک آور فلو",
        COMPANY_NAME: "نام سازمان/ شرکت",
        JOB_TITLE: "عنوان شغل",
        ADDRESS: "آدرس",
        JOB_GROUP: "گروه شغلی",
        JOB_ACTIVITY: "شرح وظایف‌ و مسئولیت‌ها",
        JOB_STATUS: "وضعیت کاری",
        JOB_CAUSE_CUT: "علت قطع همکاری",
        DESCRIPTION: "توضیحات",
        ATTACHED: "پیوست شده",
        FILE: "فایل",
        FILE_TYPE: "نوع فایل",
        USER_RESUMES_IN_OTHER_JOBS:
          "این کارجو در فرصت‌های شغلی دیگر نیز رزومه ارسال کرده است.",
        SHOW: "مشاهده",
        JOBS: "فرصت شغلی",
        SHOW_RESUME: "مشاهده رزومه",
        OTHER_FIELDS: "سایر اطلاعات",
        COMMITTE: "عضویت کمیته امداد",
        COURSES: "دوره‌های آموزشی",
        COURSE_TITLE: "عنوان دوره",
        COURSE_ACADEMY_TITLE: "نام آموزشگاه",
        COURSE_TIME: "مدت دوره",
        COURSE_DATE: "تاریخ شرکت در دوره",
        COURSE_TEXT: "توضیحات",
        ADD: "افزودن",
        CANCEL: "انصراف",
        DELETE: "حذف",
        DELETE_IMAGE: "حذف عکس",
        FILE_UPLOADED: "فایل جدید بارگذاری شد",
        IMAGE_UPLOADED: "تصویر جدید بارگذاری شد",
        APPLY: "ثبت",
        DELETE_MODAL_TXT: "آیا از حذف این قسمت اطمینان دارید؟",
        NOT_SELECTED: "نامشخص",
        UPLOAD_FILE: "بارگذاری فایل ضمیمه",
        EDIT_IMAGE: "ویرایش عکس",
        DRAG_AND_DROP_FILE: "یا داخل باکس کشیده و رها کنید",
        SELECT_IMAGE: "عکس را انتخاب کنید",
        SAVE_IMAGE: "ذخیره عکس",
        ABOUT_ME: "درباره من",
        WITH: "با",
        FROM: "از",
        TO: "تا",
        HOURS: "ساعت",
        EDIT_ABOUT_ME: "ویرایش درباره من",
        BIRTH_CERTIFICATE_IMAGE: "تصویر شناسنامه",
        LAST_DEGREE_IMAGE: "تصویر آخرین مدرک تحصیلی",
        MILITARY_SERVICE_IMAGE: "تصویر کارت پایان خدمت",
        NATIONAL_CARD_IMAGE: "تصویر کارت ملی",
        IDENTITY_DOCUMENTS: "مدارک شناسایی",
        NOT_SHOW_FILE: "فایل غیرقابل نمایش است",
      },
    },
    RESUME: {
      DETAIL: {
        INDEX: {
          USER_RESUMES_IN_OTHER_JOBS:
            "این کارجو در فرصت‌های شغلی دیگر نیز رزومه ارسال کرده است.",
        },
      },
      DUPLICATE: {
        IS_DUPLICATE_RESUME: "رزومه تکراری وجود دارد.",
        SHOW_RESUME: "نمایش رزومه",
        RESUME_DATE: "تاریخ دریافت رزومه",
        RESUME_MERGE: "ادغام رزومه",
        RESUME_STEP: "مرحله رزومه",
        RESUME_LOGS: "تاریخچه رزومه",
        JOB_TITLE: "عنوان شغل",
        INSERT: "ثبت",
        AOTU_MERGE_MESSAGE: "رزومه با موفقیت ادغام شد.",
        DESCRIPTION:
          "رزومه‌هایی که قصد ادغام کردن آن‌ها را دارید، در بعضی موارد با هم اختلاف یا تناقض دارند، لطفاً در لیست زیر انتخاب کنید که مایلید کدام اطلاعات در رزومه‌ی ادغام‌شده وارد شوند. سپس دکمه ثبت را بزنید.",
      },
      RESUME_CARD: {
        JOB_TITLE: "فرصت شغلی",
        RECEIVED_DATE: "تاریخ دریافت",
        SEND_MESSAGE: "ارسال پیام",
        NO_TAG: "بدون‌برچسب",
        OTHER_TAG: "برچسب دیگر",
        ASSIGN_DATE: "تاریخ ارجاع",
        JOBS: "شغل‌ها",
        SKILLS: "مهارت‌ها",
        YEAR: "سال",
        SHOW_RESUME: "نمایش رزومه",
      },
      RESUME_CARD_STEP: {
        RECEIVED_DATE: "دریافت",
        NEW: "جدید",
        SEND_TO_ARCHIVE: "ارسال به بایگانی",
        SEND_TO_NEXT_STEP: "ارسال به مرحله بعد",
        SEND_TO_PREV_STEP: "ارسال به مرحله قبل",
        BACK_TO_HIRING: "بازگشت به چرخه استخدام",
        SHOW_ALL_TAG: "مشاهده برچسب‌ها",
        TAGS: "برچسب‌ها",
        CLOSE: "بستن",
        UNSEEN_RESUME: "رزومه جدید است و قبلاً آن را ندیده‌اید.",
        SEEN_RESUME: "شما قبلا این رزومه را دیده‌اید.",
        NOTE: "برای این رزومه {count} یادداشت نوشته شده است.",
        NO_NOTES: "برای رزومه یادداشتی نوشته نشده است.",
        HAS_INTERVIEW_DATE: "تاریخ مصاحبه: \n {date}",
        NO_INTERVIEW_DATE: "برای کارجو تاریخ مصاحبه تنظیم نشده است.",
        TEST: "کارجو به {count} پرسشنامه پاسخ داده است.",
        NO_TESTS: "کارجو به پرسشنامه‌ای پاسخ نداده است.",
        ASSIGNED: "شما مسئول بررسی این رزومه‌اید.",
        NO_ASSIGN: "شخص دیگری مسئول بررسی این رزومه است.",
        RESUME_RECOURSE: "منبع دریافت رزومه: {name}",
        UNKNOWN: "نامشخص",
        YEAR: "سال",
        SKILLS: "مهارت‌ها",
        JOBS: "شغل‌ها",
        SHOW_RESUME: "نمایش رزومه",
        AVERAGE_SCORE: "میانگین وزنی",
      },
      RESUME_INDEX: {
        TOTAL_NUMBER_OF_RESULT_TXT: "تعداد کل نتایج",
        RESUME_TXT: "رزومه",
        SEND_GROUP_MESSAGE_BTN: "ارسال پیام گروهی",
        ORDER_BY_TXT: "مرتب سازی بر اساس",
        SEND_GROUP_MESSAGE: "ارسال گروهی پیام",
        NO_RESUMES: "رزومه‌ وجود ندارد!",
      },
      RESUME_FILTER: {
        FILTER: "فیلتر",
        TITLE: "فیلتر‌ها",
        PERSONAL_PROFILE: "مشخصات فردی",
        ADDRESS: "شهر و استان",
        EDUCATION: "مشخصات تحصیلی",
        JOB_EXPERIENCE: "مشخصات شغلی",
        SKILL: "مهارت",
        LANGUAGE: "زبان",
        TAG: "برچسب",
        OTHER: "سایر",
        DELETE_FILTER_TEXT: "حذف فیلتر",
        GENDER: "جنسیت",
        BIRTHDAY: "تاریخ تولد",
        MILITARY_SERVICE: "وضعیت نظام وظیفه",
        EMPLOYMENT_STATUS: "وضعیت اشتغال به کار",
        FIELD: "گرایش تحصیلی",
        MAJOR: "رشته تحصیلی",
        UNIVERSITY: "دانشگاه",
        GPA: "معدل",
        GRADE: "مقطع تحصیلی",
        EDUCATIONAL_STATUS: "وضعیت تحصیلی",
        ORGANIZATION_NAME: "نام سازمان",
        JOB_TITLE: "عنوان شغل",
        JOB_GROUP: "گروه شغلی",
        LEVEL: "سطح ارشدیت",
        SKILL_TITLE: "عنوان مهارت",
        JOB_OPPORTUNITY: "فرصت شغلی",
        STEP: "مرحله",
        SEARCH_PLACEHOLDER: "جستجو کنید",
        FROM_YEAR: "از سال ",
        TO_YEAR: "تا سال ",
        FROM: "از",
        TO: "تا",
        NO_DATA: "نتیجه‌ای یافت نشد!",
      },
      RESUME_FIELDS: {
        FIELD_TITLE: "عنوان فیلد",
        VIEW_STATUS: "وضعیت نمایش در فرم",
        CONFIDENTIALITY_STEP: "سطح محرمانگی",
        DEACTIVATE_FIELDS: "هیچ کدام از فیلدهای {name} رزومه را نمایش نده",
        DELETE: "حذف",
        EDIT: "ویرایش",
        SHOW: "نمایش",
        DELETE_MODAL_TXT: "آیا از حذف این فیلد اطمینان دارید؟",
        ACCESS_FIELDS_MESSAGE: "شما به ویرایش فرم رزومه دسترسی ندارید!",
      },
      RESUME_EDIT_MODAL: {
        TITLE: "ویرایش رزومه",
        EDIT: "ویرایش",
        FIRST_NAME: "نام",
        LAST_NAME: "نام خانوادگی",
        MOBILE: "تلفن همراه",
        EMAIL: "ایمیل",
        PHONE: "تلفن ثابت",
        NATIONAL_CODE: "کد ملی",
        GENDER: "جنسیت",
        CITY: "استان و شهر",
        FEMALE: "زن",
        MALE: "مرد",
        NOT_SELECTED: "انتخاب نشده",
      },
      RESUME_GUEST_EXPERT_MODAL: {
        TITLE: "ارسال لینک به کارشناس مهمان",
        USERNAME: "ایمیل یا موبایل",
        TIME_PLACEHOLDER: "مدت اعتبار لینک (روز)",
        TIME: "مدت اعتبار",
        SEND_LINK: "ارسال لینک",
      },
      RESUME_SEND_TO_ARCHIVE_MODAL: {
        TITLE: "ارسال رزومه به بایگانی",
        REASON_REJECTION: "علت رد کارجو",
        DESCRIPTION: "یادداشت",
        SEND: "ارسال",
      },
      RESUME_DOWNLOAD_PRINT: {
        DOWNLOAD_RESUME: "دانلود رزومه",
        PRINT_RESUME: "چاپ رزومه",
      },
      RESUME_ADD_TAG: {
        ADD_TAG: "افزودن برچسب",
        ADD: "افزودن",
        ADD_TAG_PLACEHOLDER: "نام برچسب را بنویسید",
      },
      RESUME_DUPLICATE_BOX: {
        NO_INSERT: "ثبت نشده",
        SELECT: "انتخاب",
        SHOW: "مشاهده",
        NO_INSERT_ITEM: "موردی ثبت نشده است!",
      },
      RESUME_DUPLICATE: {
        PERSONAL_PROFILE: "مشخصات فردی",
        EDUCATIONAL_RECORD: "سوابق تحصیلی",
        JOB_EXPERIENCE: "سوابق شغلی",
        SKILLS: "مهارت‌ها",
        LANGUAGE: "زبان‌ها",
        COURSES: "دوره‌های آموزشی",
        PROJECTS: "پروژه‌ها",
        HONORS: "افتخارات",
        CONTACT: "راه‌های ارتباطی",
        OTHER_DESCRIPTION: "توضیحات دیگر",
        SHOW_RESUME_FILE: "نمایش فایل رزومه",
      },
      RESUME_SET_INTERVIEW_TIME: {
        TITLE: "تنظیم زمان مصاحبه",
        INSERT: "ثبت",
        USERS: "افراد حاضر در مصاحبه",
        DATE: "تاریخ و ساعت",
        IS_MESSAGE_PATTERN:
          "با توجه به قوانینی که برای مرحله «<span class='font-weight-bolder primary-color'>{step}</span>» تنظیم کرده‌اید، پس از تنظیم زمان مصاحبه پیام‌های زیر به کارجو ارسال می‌شود",
        NO_MESSAGE_PATTERN:
          "با توجه به قوانینی که برای مرحله «<span class='font-weight-bolder primary-color'>{step}</span>» تنظیم کرده‌اید، پس از تنظیم زمان مصاحبه هیج پیامی به کارجو ارسال نخواهد شد.",
      },
      RESUME_INSERT_NOTE_MODAL: {
        INSERT_NOTE: "ثبت یادداشت",
        NOTE_TEXT: "متن یادداشت",
        INSERT: "ثبت",
      },
    },
    TAG: {
      TAG_CARD: {
        TITLE: "نام برچسب",
        COUNT: "تعداد رزومه",
        DESCRIPTION: "توضیحات",
        COUNT_TEXT: "مورد",
        EDIT_BTN_TXT: "ویرایش",
        DELETE_BTN_TXT: "حذف",
        NOT_ATTACHED: "به هیچ رزومه‌ای الصاق نشده است.",
      },
      TAG_MODAL: {
        ACTIVATOR: "افزودن برچسب جدید",
        NEW_ITEM_TITLE: "افزودن برچسب جدید",
        EDIT_ITEM_TITLE: "ویرایش برچسب",
        NAME_PLACEHOLDER: "نام",
        DESCRIPTION_PLACEHOLDER: "توضیحات",
        SELECT_TAG_TEXT: "انتخاب رنگ برچسب",
        SUBMIT_BTN_TEXT: "افزودن",
        EDIT_BTN_TEXT: "ویرایش",
      },
    },
    ROLE: {
      ROLE_CARD: {
        ROLE: "نقش",
        COLLEAGUE_COUNT: "تعداد همکاران",
        PERSON: "نفر",
        EDIT_BTN: "ویرایش",
        DELETE_BTN: "حذف",
        COPY: "ایجاد کپی",
      },
    },
    JOB: {
      JOB_STAT_LIST: {
        RESUME_REGISTER_BTN: "ثبت رزومه",
        MASS_RESUME_REGISTER_BTN: "آپلود انبوه رزومه",
        EDIT_BTN: "ویرایش",
        COPY_BTN: "ایجاد کپی",
        PUBLISHER: "انتشار دهنده",
        PUBLISHER_BTN: "انتشار آگهی در {count} وبسایت",
        INTEGRATION_BTN: "یکپارچه سازی",
        DISABLE_BTN: "غیر فعال کردن",
        ENABLE_BTN: "فعال کردن",
        TIMING: "زمان‌بندی",
        TIMING_MODAL_TITLE: "زمان‌بندی غیرفعال شدن فرصت شغلی",
        SHARED_LINK_TITLE: "لینک ثبت رزومه برای فرصت شغلی",
        LINK_COPY_TOOLTIP:
          " این لینک را در آگهی استخدامی خود قرار دهید یا به اشخاص مورد نظر خود ارسال کنید.  کارجویان با کلیک روی این لینک به صفحه‌ی حاوی فرم ثبت رزومه هدایت میشوند.",
        HTML_COPY_TOOLTIP:
          "این کد را در صفحه‌ی دلخواه از سایت خود کپی کنید تا فرم ثبت نام کارجویان در همان صفحه قرار بگیرد.",
        CONNECT_TO_EESTEKHTAM: "اتصال به ای‌استخدام",
        CONNECT_TO_JOBINJA: "اتصال به جابینجا",
        CONNECT_TO_JOBVISION: "اتصال به جاب‌ ویژن",
        NOT_ACTIVE_JOB_MESSAGE: "فرصت شغلی غیر فعال است!",
        DATE: "تاریخ",
        INSERT: "ثبت",
        DELETE: "حذف",
        MOVE: "جابجایی",
        MOVE_UP: "انتقال به بالای",
        MOVE_JOB: "جابجایی فرصت شغلی",
        JOBS: "فرصت شغلی",
        PRIVATE_EMAIL: "ایمیل اختصاصی",
        INSERT_PUBLISH_REQUEST: "ثبت درخواست انتشار آگهی",
        SOHA_PUBLISH_DESCRIPTION:
          "این آگهی در رسانه استخدامی سها منتشر نشده است، در صورت تمایل به انتشار آگهی و دریافت رزومه‌های بیشتر روی دکمه زیر کلیک کنید",
      },
      JOB_PIPELINE_STEP: {
        EDIT: "ویرایش",
        DELETE: "حذف",
        RULES_MESSAGE: "برای این مرحله قانون تنظیم شده است",
        MESSAGE_PATTERN: "برای این مرحله پیام اتوماتیک تنظیم شده است",
        NOT_MODIFY:
          "در حال حاضر درخواست جذبی در این مرحله وجود دارد و تا زمان تعیین تکلیف آن درخواست امکان ویرایش یا حذف مرحله وجود ندارد",
      },
      JOB_MODAL_STEP: {
        INSERT_CHANGE: "ثبت تغییرات",
        ADD_NEW_STEP: "افزودن مرحله جدید",
        EDIT_STEP: "ویرایش مرحله",
        STEP_NAME: "نام مرحله",
        ADD: "افزودن",
        ADD_RULE: "افزودن قانون",
        EDIT_RULE: "ویرایش قانون",
        CLOSE_BOX: "بستن",
        TYPE_CONDITION: "شرط اجرای قانون",
        ORIGIN_STEP: "مرحله مبدا",
        STEPS: "مراحل",
        RESOURCES: "منابع دریافت رزومه",
        TIME_PERIOD: "مدت زمان",
        TIME_PERIOD_DELAY: "مدت زمان تأخیر",
        TEST_TIME_PERIOD: "حداکثر مهلت پاسخگویی (بر حسب روز)",
        TIME_UNIT: "واحد زمانی",
        REASONS: "دلیل رد",
        REASON_REJECT: "دلیل رد کارجو",
        QUESTIONNAIRE: "پرسشنامه",
        SCORE_LEVEL: "نمره",
        COMPLETE: "کامل شدن",
        CHECK_LIST: "چک‌لیست",
        SCORE: "نمره",
        SCORING_COUNT: "تعداد نمره دهندگان",
        ACTION_TO_BE_DONE: "عملیاتی که باید اجرا شود",
        ACTION: "عملیات",
        ADD_ACTION: "افزودن عملیات",
        TAGS: "برچسب‌ها",
        SMS: "پیامک",
        EMAIL: "ایمیل",
        SYSTEM: "سامانه",
        SENDING_METHOD: "روش ارسال",
        MESSAGE_PATTERN: "الگوی پیام",
        SHOULD_DEFAULT_MESSAGE_BE_SEND:
          "آیا پیام پیش‌فرض مرحله بایگانی ارسال شود؟",
        YSE: "بله",
        NO: "خیر",
        NOTE_TEXT: "متن یادداشت",
        EMPLOYEES: "نام همکار",
        ACTION_METHOD: "نحوه انجام عملیات",
        OPTIONS_NOT_SEECTED_ERROR: "حداقل یک گزینه را انتخاب کنید",
        CHECK_OPTION_ERROR: "لطفا یکی از گزینه هارا انتخاب کنید",
        TIME_LEFT_INTERVIEW: "زمان مانده به مصاحبه",
        API_METHOD: "متد API",
        API_URL: "آدرس API",
        NOT_VALID_API_URL: "آدرس API باید شامل http یا https باشد.",
        SCORING_CARD: "فرم ارزیابی (کارت امتیازدهی)",
        NO_ACCESS_TO_CREATE:
          "تعداد مراحل به حداکثر مجاز در طرح شما رسیده است، لطفاً در صورت تمایل از طریق منوی «مالی» طرح خود را ارتقا دهید.",
        CANCEL: "انصراف",
        TASK_TIME: "مهلت انجام(براساس‌ روز)",
        TASK_TYPE: "نوع وظیفه",
        DESCRIPTION: "توضیحات",
        CLOSE: "بستن",
        DELETE_MODAL_TXT: "آیا از حذف قانون اطمینان دارید؟",
        EDIT: "ویرایش",
        PREVIEW: "پیش نمایش الگوی پیام",
        CONDITION_TEMPLATE: "الگوی قانون",
        CONDITION_TEMPLATE_DESCRIPTION:
          "با انتخاب این گزینه الگویی که قبلا ذخیره کرده‌اید به شما نمایش داده می شود و با ثبت آن، قوانین برای این مرحله اعمال می‌شود . ",
        ADD_TEMPLATE: "افزودن الگو",
        EDIT_TEMPLATE: "ویرایش الگو",
        SAVE_TEMPLATE: "ذخیره قوانین به عنوان یک الگوی قانون جدید",
        TEMPLATE_NAME: "نام الگو",
        INSERT_CONDITION: "ثبت",
        CONFIRM_CLOSE_DESCRIPTION:
          "تغییراتی که در تنظیمات اعمال کرده‌اید ذخیره نشده اند",
        CONFIRM_MODAL_TITLE: "هشدار",
        ADD_RULE_TO_TEMPLATE: "ثبت قوانین زیر به عنوان الگو",
        IMPORT_OTHER_TEMPLATE: "ورود قوانین مطابق الگوهای قبلی",
        SELECT_RULE: "انتخاب الگوی قوانین",
        ADD_NEW_RULE: "افزودن الگوی قوانین",
        REMOVE_STEP_RULES: "حذف قوانین قبلی مرحله"
      },
      JOB_MODAL_ADD_FIELD: {
        FIELD_TITLE: "عنوان آیتم",
        FIELD_TYPE: "نوع آیتم",
        ITEM_OPTIONS: "گزینه‌ها",
        ITEM_CONFIDENTIALITY: "محرمانگی",
        ITEM_OPTIONS_TITLE: "عنوان گزینه",
        ADD_NEW_STEP: "افزودن آیتم",
        DELETE: "حذف",
        SELECT: "لیست کشویی",
        INPUT: "متن کوتاه",
        TEXTAREA: "متن  بلند",
        RADIOBUTTON: "تک انتخابی",
        CHECKBOX: "چند انتخابی",
        FILE: "فایل",
      },
      JOB_MODAL_COPY_PRIVATE_EMAIL: {
        COPY_PRIVATE_EMAIL: "کپی ایمیل اختصاصی",
        CLOSE: "بستن",
        DESCRITION:
          "در صورتی که کارجویان فایل pdf یا word رزومه خود را به آدرس ایمیل زیر ارسال کنند، رزومه آن‌ها در این فرصت شغلی دریافت خواهد شد.",
      },
      JOB_STEP: {
        STEP1: "اطلاعات آگهی",
        STEP2: "دسترسی افراد",
        STEP3: "مراحل استخدام",
        STEP4: "فرم رزومه",
      },
      JOB_INTEGRATION_JOB_BOARDS: {
        TITLE: "اتصال فرصت شغلی «{title}» به جاب‌بوردها",
        JOB_BOARD_SELECT: "انتخاب جاب بورد",
        DELETE: "حذف",
        ADD: "اضافه کردن",
        INSERT: "ثبت",
        NO_JOB_BOARD: "جاب بورد انتخاب نشده است",
        PUBLISH_JOBS_SEARCH: "جستجو در آگهی های منتشر شده در جاب بوردها",
        NOT_SHOW_EXPIRED_JOB: "عدم نمایش آگهی‌های منقضی شده",
        NOT_SHOW_CONECTED_JOB: "عدم نمایش آگهی‌های متصل به فرصت‌های شغلی دیگر",
        SHARE_NEW_JOB:
          "آگهی جدیدی منتشر کرده‌اید که هنوز در لیست بالا ظاهر نشده است؟",
        UDPATE_LIST: "به‌روز رسانی لیست",
        NO_MORE_JOB: "آگهی بیشتری وجود ندارد",
        NO_JOB: "آگهی وجود ندارد",
        NOT_JOB_BOARD_INTEGRATE_TEXT_MODAL:
          "برای اتصال این فرصت شغلی به {jobBoardName}, لازم است ابتدا در بخش تنظیمات، حساب کاربری {jobBoardName} را با سها یکپارچه کنید.",
        CANCEL: "انصراف",
        GO_TO_SETTING: "ورود به تنظیمات",
      },
      JOB_JOB_BOARD_AD: {
        ENABLE: "فعال",
        EXPIRE: "منقضی شده",
        JOB_CODE: "کد آگهی",
        USERNAME: "شناسه کاربری",
        SHOW_IN: "مشاهده در",
        CONNECT: "متصل کردن",
        CONNECTED: "متصل‌شده",
      },
      JOB_PIPELINE_GROUP_ACTION_MENU: {
        ALL_RESUME_TO_ARCHIVE: "ارسال همه رزومه‌‌ها به بایگانی",
        ALL_RESUME_TO_NEXT_STEP: "ارسال همه رزومه‌ها به مرحله بعد",
        SEEN_ALL_RESUME: "علامت گذاری رزومه‌ها به عنوان خوانده شده",
        STEP_REPORT: "گزارشات مرحله",
        SETTING: "تنظیمات",
      },
      JOB_PUBLISH_INVOICE_MODAL: {
        PAYMENT: "پرداخت",
        INVOICE: "صورت حساب",
        JOB_NAME: "نام فرصت شغلی",
        PERIOD: "مدت انتشار",
        DAY: "روز",
        TAX: "مالیات برارزش افزوده",
        TOMAN: "تومان",
        AMOUNT: "هزینه انتشار",
        AMOUNT_PAYABLE: "مبلغ قابل پرداخت",
        PAYMENT_GATEWAY: "درگاه پرداخت",
      },
      JOB_STEP_REPORT_MODAL: {
        STEP_REPORTS: "گزارشات مرحله",
        START_DATE: "تاریخ شروع",
        END_DATE: "تاریخ پایان",
        CHART_TYPE: "نوع نمودار",
        REPORT_TYPE_ENTRY: "توزیع رزومه وارد شده",
        REPORT_TYPE_EXIT: "توزیع رزومه‌های خارج شده",
        REPORT_TYPE_REJECT: "توزیع رزومه‌های بایگانی شده",
        REPORT_RESUME_COUNT: "گزارش تعداد رزومه‌ها",
        REPORT_WAITING_TIME: "گزارش زمان انتظار رزومه‌‌ها",
        BASED_ON_AGE: "به تفکیک سن",
        BASED_ON_GENDER: "به تفکیک جنسیت",
        BASED_ON_EXPRIENCE: "به تفکیک سابقه کار",
        BASED_ON_DEGREE: "به تفکیک تحصیلات",
        BASED_ON_RESOURCE: "به تفکیک منبع",
      },
    },
    INVITATION: {
      MEMBER_INVITATION_CARD: {
        PHONE_OR_EMAIL: "ایمیل / تلفن:",
        DATE: "زمان و تاریخ:",
        DELETE: "حذف",
        SEND_AGAIN: "ارسال مجدد",
        ROLE: "نقش:",
        POST: "سمت:",
        STATUS: "وضعیت:",
        TODAY: "امروز",
        PASSED_DAYS: "روز قبل",
        NO_INSERT: "ثبت نشده",
        NO_REGISTERED: "ثبت نام نشده",
        REGISTERED: "ثبت نام شده",
      },
    },
    MEMBER: {
      MEMBER_CARD: {
        EDIT: "ویرایش",
        DELETE: "حذف",
        ROLE: "نقش",
        POST: "سمت",
        OTHER_JOB: "شغل دیگر",
        SHOW: "مشاهده",
        JOBS: "شغل‌های",
      },
      MEMBER_EDIT_MODAL: {
        TITLE: "ویرایش همکار",
        POST: "سمت",
        ROLE: "نقش",
        ROLE_TOOLTIP: "توضیحات نقش",
        POST_TOOLTIP: "توضیحات سمت",
        PERSONNEL_CODE: "کد پرسنلی",
        JOBS: "شغل‌های در‌ دسترس",
        EDIT_BTN_TEXT: "ویرایش کاربر",
        ACCESS_ALL_JOB: "کاربر ارشد سامانه به همه‌ی فرصت‌های شغلی دسترسی دارد.",
      },
    },
    TICKET: {
      TICKET_CARD: {
        DEPARTMENT: "دپارتمان",
        LAST_ANSWER_TIME: "تاریخ آخرین پاسخ",
      },
    },
    SETTING: {
      MANAGE_MESSAGE_PATTERN: {
        INSERT_MESSAGE_COMPONENT: "درج اطلاعات متغییر در متن پیام",
        ADD_MESSAGE: "افزودن الگوی پیام",
        EDIT_MESSAGE: "ویرایش الگوی پیام",
        NAME: "نام الگوی پیام",
        PREVIEW: "پیش نمایش",
        TEXT: "متن پیام",
        INSERT: "افزودن",
        SAMPLE: "مثال",
        EDIT_BTN: "ویرایش",
      },
    },
  },
  PAGES: {
    AUTH: {
      HEADER: {
        SEARCH_PLACEHOLDER: "جستجو در رزومه‌ها",
        QUICK_SEARCH: "جستجوی سریع",
        DASHBOARD: "میز کار",
        JOBS: "شغل‌ها",
        RESUMES: "بانک رزومه",
        TASKS: "وظیفه‌‌ها",
        RESUME_ASIGN: "رزومه‌های ارجاع شده",
        INTERVIEWS: "تقویم مصاحبه",
        EMPLOYEES: "وظایف همکاران",
        REPORTS: "گزارش‌ها",
        VISIT_REPORT: "آمار بازدید",
        JOBSEEKER_REPORT: "گزارش کارجویان",
        EMPLOYEE_REPORT: "گزارش کارشناسان",
        MESSAGE_REPORT: "گزارش پیام‌های ارسال شده",
        SETTING: "تنظیمات و فرم‌ها",
        ADVANCE_SEARCH_TEXT_BEFORE: "برای جستجوی پیشرفته از بخش ",
        ADVANCE_SEARCH_TEXT_AFTER: " استفاده کنید.",
      },
      LOGIN: {
        PAGE_TITLE: "ورود کارفرمایان",
        LOGIN_BTN_TEXT: "ورود",
        REGISTER_BTN_TEXT: "ثبت نام",
        FORGOT_PASSWORD_TEXT: "کلمه عبورم را فراموش کرده‌ام!",
        USERNAME_PLACEHOLDER: "شماره موبایل یا آدرس ایمیل",
        PASSWORD_PLACEHOLDER: "کلمه عبور",
        WRONG_USERNAME_OR_PASSWORD_ERR: "نام کاربری یا کلمه عبور اشتباه است!",
        LOGIN_FROM_INVITATION_MESSAGE: "برای تایید عضویت، باید وارد شوید.",
        IS_JOBSEEKER: "کارجو هستید؟",
        JOBSEEKER_LOGIN: "ورود به بخش کارجویان",
        OR: "یا",
      },
      M_LOGIN: {
        PAGE_TITLE: "ورود کارفرمایان",
        LOGIN_BTN_TEXT: "ورود",
        USERNAME_PLACEHOLDER: "کد ملی",
        PASSWORD_PLACEHOLDER: "کلمه عبور",
        DESCRIPTION: " داوطلب گرامی، چنانچه در آزمون استخدامی نمره‌ی قبولی را کسب کرده باشید، کلمه عبور از طریق پیامک به شما ارسال شده است."
      },
      AUTO_LOGIN: {
        WRONG_USERNAME_OR_PASSWORD_ERR: "نام کاربری یا کلمه عبور اشتباه است!",
        NO_SERVER_CONNECT:
          "ارتباط با سرور برقرار نشد، لطفاً دوباره امتحان کنید.",
      },
      FORGET_PASSWORD: {
        PAGE_TITLE: "بازیابی کلمه عبور",
        USERNAME_PLACEHOLDER: "ایمیل یا شماره موبایل",
        SEND_SMS_TEXT: "کد تایید به شماره زیر ارسال شد",
        USERNAME: "نام کاربری",
        RESEND: "ارسال مجدد",
        SEND: "ارسال",
        CONTINUE: "ادامه",
        CODE: "کد اعتبارسنجی",
        SERVER_ERROR:
          "در زمان ارتباط با سرور خطایی پیش آمد. لطفا دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.",
        RESTART_RESET_PASSWORD_ERROR:
          "به نظر می‌رسد خطایی به وجود آمده است. لطفا فرایند بازیابی را دوباره شروع کنید.",
        WRONG_CODE: "کد اعتبارسنجی صحیح نیست.",
        WRONG_USERNAME: "ایمیل یا کلمه عبور اشتباه است.",
        BACK_TO_LOGIN: "بازگشت به صفحه ورود",
      },
      RESET_PASSWORD: {
        PASSWORD: "کلمه عبور",
        PASSWORD_REPEAT: "تکرار کلمه عبور",
        CHANGE_PASSWORD: "تغییر کلمه عبور",
        REPEAT_PASS_ERROR: "تکرار رمز را به صورت صحیح وارد کنید",
        EMPTY_REPEAT_PASS: "لطفا تکرار رمز را وارد کنید",
        BACK_TO_LOGIN: "بازگشت به صفحه ورود",
      },
      REGISTER_STEP_ONE: {
        PAGE_TITLE: "فرم ثبت‌نام",
        PAGE_DESCRIPTION: "مرحله اول: مشخصات فردی کاربر",
        NAME_PLACEHOLDER: "نام",
        FAMILY_PLACEHOLDER: "نام خانوادگی",
        EMAIL_PLACEHOLDER: "آدرس ایمیل",
        PHONE_PLACEHOLDER: "شماره موبایل",
        PASSWORD_PLACEHOLDER: "کلمه عبور",
        REPEAT_PASSWORD_PLACEHOLDER: "تکرار کلمه عبور",
        NEXT_STEP_BTN_TEXT: "مرحله بعد",
        WRONG_REPEAT_PASSWORD_ERR: "تکرار کلمه عبور صحیح نمی باشد",
        SOHA_WATERMARK: "Soha ATS",
      },
      REGISTER_STEP_TWO: {
        PAGE_TITLE: "فرم ثبت‌نام",
        PAGE_DESCRIPTION: "مرحله دوم: مشخصات شرکت",
        COMPANY_NAME_PLACEHOLDER: "نام شرکت",
        COMPANY_WEBSITE_PLACEHOLDER: "وبسایت شرکت",
        NUMBER_OF_EMPLOYERS_PLACEHOLDER: "تعداد کارمندان",
        COMPANY_FIELD_PLACEHOLDER: "زمینه کاری",
        SUBMIT_BTN_TEXT: "ثبت نهایی",
        PREVIOUS_STEP_BTN_TEXT: "مرحله قبل",
        SOHA_WATERMARK: "Soha ATS",
      },
      INVITE: {
        LOGOUT: "خروج از سامانه و ورود با کاربر دعوت شده",
        FIRST_NAME: "نام",
        LAST_NAME: "نام خانوادگی",
        MOBILE: "موبایل",
        EMAIL: "ایمیل",
        PASSWORD: "رمز عبور",
        PASSWORD_REPEAT: "تکرار رمز عبور",
        ACCEPT: "تایید دعوت نامه",
        REJECT: "انصراف",
        REPEAT_PASS_ERROR: "تکرار رمز را به صورت صحیح وارد کنید",
        EMPTY_REPEAT_PASS: "لطفا تکرار رمز را وارد کنید",
        USED_LINK_DESCRIPTION:
          "لینک ثبت نام قبلا استفاده شده است و دیگر معتبر نیست. برای ورود به سامانه لطفا وارد آدرس زیر شوید.",
      },
      PRE_REGISTRATION: {
        PAGE_TITLE: "پیش ثبت نام کارفرما",
        COMPANY_NAME: "نام شرکت",
        WEBSITE: "وب سایت",
        GENDER: "جنسیت",
        FIELD: "زمینه کاری",
        MEMBER_COUNT: "تعداد کارمندان",
        CITY: "استان - شهر",
        PHONE: "تلفن",
        DATE_ESTABLISHMENT: "تاریخ تاسیس",
        ADDRESS: "آدرس",
        INSERT: "ثبت",
        NOT_SELECTED: "بدون انتخاب",
        PERSONAL_INFORMATION: "اطلاعات فردی",
        COMPANY_INFORMATION: "اطلاعات شرکت",
        FIRST_NAME: "نام",
        LAST_NAME: "نام خانوادگی",
        MOBILE: "موبایل",
        EMAIL: "ایمیل",
        PASSWORD: "کلمه عبور",
        PASSWORD_REPEAT: "تکرار کلمه عبور",
        DESCRIPTION: "توضیحات",
        WRONG_REPEAT_PASSWORD_ERR: "تکرار کلمه عبور صحیح نمی باشد",
        MANAGE_NAME: "نام مدیر",
        DUPLICATE_EMAIL_MOBILE: "ایمیل/موبایل قبلا ثبت نام شده است.",
        LOGIN: "ورود به حساب کاربری",
        FORGET_PASSWORD_MESSAGE: "کلمه عبور خود را فراموش کرده‌اید؟",
        FORGET_PASSWORD: "بازیابی کلمه عبور",
        DUPLICATE_INFO: "اطلاعات تکراری",
        CANCEL: "انصراف",
        UPLOAD_NEW_LOGO: "بارگذاری لوگوی جدید",
        UPLOAD_LOGO: "بارگذاری لوگو",
        CRROPPED_IMAGE: "برش تصویر",
        REGISTERED_MESSAGE:
          "پیش ثبت نام شما با موفقیت انجام شد، منتظر تایید توسط کارشناسان ما باشید",
      },
    },
    DASHBOARD: {
      INDEX: {
        EXPIRE_WARNING_ONE_PART:
          "طرح اشتراک فعال شرکت شما {remainingDays} روز دیگر منقضی می‌شود، لطفا برای تمدید طرح خود به صفحه",
        EXPIRE_WARNING_TWO_PART: "مراجعه کنید.",
        PLANS_PAGE: "خرید/تمدید اشتراک",
      },
      SECTIONS: {
        LAST_JOBS: {
          LAST_JOBS: "آخرین فرصت‌های شغلی",
          CREATE_JOB_OPPORTUNITY_BTN: "ایجاد فرصت شغلی",
          LINK_COPY_BTN: "کپی لینک",
          HTML_COPY_BTN: " HTML کپی کد",
          LINK_COPY_TOOLTIP:
            "کارجویان با کلیک برروی این‌ لینک به صفحه حاوی لیست فرصت‌های شغلی فعال شما هدایت می شود و می‌توانند برای هرکدام که مایلند رزومه ثبت کنند",
          HTML_COPY_TOOLTIP:
            "این کد را در صفحه‌ی دلخواه از سایت خود کپی کنید. تا لیست فرصت‌های شغلی فعال شما در آن صفحه قرار بگیرد و کارجویان بتوانند برای هرکدام که تمایل دارند رزومه ارسال کنند.",
          SHOW_MORE: "مشاهده بیشتر",
        },
        LAST_RESUMES_ASSIGN: {
          NO_DATA: "رزومه به شما ارجاع نشده است.",
          PAGE_TITLE: "آخرین رزومه‌های ارجاع شده به من",
          SHOW_MORE: "مشاهده بیشتر",
        },
        LAST_RESUMES: {
          NO_DATA: "رزومه‌ای وجود ندارد.",
          PAGE_TITLE: "آخرین رزومه‌های دریافتی",
          SHOW_MORE: "مشاهده بیشتر",
        },
        LAST_RECRUITMENT_REQUEST: {
          NO_DATA: "درخواست جذبی وجود ندارد.",
          PAGE_TITLE: "آخرین درخواست‌های جذب",
          SHOW_MORE: "مشاهده بیشتر",
        },
        LAST_USERS: {
          NO_DATA: "کاربری وجود ندارد.",
          PAGE_TITLE: "جدیدترین همکاران",
          SHOW_MORE: "مشاهده بیشتر",
          DELETE_MODAL_TXT: "آیا از حذف این همکار اطمینان دارید؟",
          ASSIGN_JOBS_MODAL_TITLE: "تغییر دسترسی شغل",
        },
      },
    },
    TAG: {
      INDEX: {
        PAGE_TITLE: "مدیریت برچسب‌ها",
        DELETE_MODAL_TXT: "آیا از حذف این برچسب اطمینان دارید؟",
        LAST_CARD_TXT: "افزودن برچسب جدید",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
      },
    },
    JOB: {
      CREATE: {
        INDEX: {
          TITLE: "افزودن فرصت شغلی",
          ACCESS_MESSAGE: ACCESS_MESSAGE,
          JOB_OPPORTUNITY_REGISTRATION: "ثبت فرصت شغلی",
          CONTINUE: "ادامه",
          ACCESS_STEP_MESSAGE:
            "برای اعضای انتخاب شده حداقل یک سطح دسترسی الزامی است.",
          PUBLISH_TO_SOHA:
            "مایلم این آگهی استخدام در رسانه استخدامی سها منتشر شود.",
          SOHA_PUBLISH_DESCRIPTION:
            "از کانال‌های مختلف (ایمیل، پیامک و ...) به کارجویان مرتبط اطلاع‌رسانی می‌شود.",
          SOHA_PUBLISH_PRICE: "۳۰۰ هزار تومان",
          FREE: "رایگان",
          PUBLISH_TO_OTHER:
            "مایلم این آگهی در رسانه‌های مرتبطی که انتشار آگهی در آن‌ها رایگان است منتشر شود.",
          OTHER_PUBLISHER_DESCRIPTION:
            "تعداد رزومه‌های دریافتی در این روش معمولاً به اندازه کافی نیست.",
          NO_PUBLISH: "نمی‌خواهم این آگهی در رسانه‌ای منتشر شود.",
          PUBLISHE_JOB: "انتشار آگهی",
        },
        STEP_ONE: {
          PAGE_TITLE: "اطلاعات آگهی",
          TITLE: "عنوان",
          JOB_CATEGORY: "دسته بندی شغلی",
          STATE_CITY: "استان / شهر",
          COOPERATION_TYPE: "نوع همکاری",
          MINIMUM_SALARY: "حداقل حقوق",
          RELATED_EXPERIENCE: "سابقه کار مرتبط",
          MINIMUM_DEGREE: "حداقل مدرک مورد نیاز",
          GENDER: "جنسیت",
          MILITARY_SERVICE_STATUS: "وضعیت خدمت سربازی",
          RESPONSIBILITIES_DESCRIPTION: "شرح وظایف و مسئولیت ها",
          JOB_OPPORTUNITY_REGISTRATION: "ثبت فرصت شغلی",
          FEMALE: "زن",
          MALE: "مرد",
          BOTH: "هردو",
          NOT_SELECTED: "انتخاب نشده",
          ADDRESS: "محدوده محل کار",
          JOB_SUB_CATEGORY: "زیرگروه شغلی",
          EMPLOYER_DESCRIPTION: "توضیحات در پنل کارفرما",
          EMPLOYER_DESCRIPTION_TOOLTIP:
            "این توضیحات فقط برای دسته‌بندی بهتر شغل‌ها توسط کارفرماست و به کارجویان نمایش داده نمی‌شود",
        },
        STEP_TWO: {
          TITLE: "دسترسی افراد",
          FIRST_LAST_NAME: "نام و نام خانوادگی",
          SELECT: "جستجو و اضافه کردن کارمندان بر اساس نام",
          POSITION: "سمت",
          ACCESS_LEVEL: "سطح دسترسی",
          DELETE: "حذف",
          ACCESS_USER_MESSAGE: "شما به لیست اعضا دسترسی ندارید!",
          MEMBER_COLLAPSE_TITLE:
            "افرادی که نقش آن‌ها «کاربر ارشد سامانه» است به همه‌ی فرصت‌های شغلی دسترسی دارند.",
          NOT_DELETE_SENIOR:
            "امکان حذف دسترسی افراد با نقش «کاربر ارشد سامانه» وجود ندارد.",
          ADD_NEW_ACCESS: "افزودن دسترسی جدید",
        },
        STEP_THREE: {
          TITLE: "مراحل استخدام",
          CUSTOM_STEP: "شخصی سازی مراحل",
          DELETE_MODAL_TXT: "آیا از حذف این مرحله اطمینان دارید؟",
          DRAG_DESCRIPTION:
            "با جابه جایی مراحل استخدام ترتیب دلخواه خود را مشخص کنید.",
          NO_ACCESS_MESSAGE:
            "شما به بخش ویرایش مراحل دسترسی ندارید! مراحل پیش فرض شرکت برای این شغل اعمال خواهد شد.",
          TEMPLATE_DESCRIPTION:
            "با انتخاب یکی از قالب‌های زیر میتوانید مراحل را با استفاده از قالب مورد نظر شخصی سازی کنید.",
        },
        STEP_FOUR: {
          TITLE: "فرم رزومه",
          DEFAULT_RESUME:
            "استفاده از فرم رزومه پیش فرض ساخته شده در قسمت تنظیمات( شخصی سازی فرم رزومه پیش فرض )",
          CUSTOM_RESUME: "شخصی سازی فرم رزومه برای این فرصت شغلی",
          OTHER_DESCRIPTION: "هیچ کدام از فیلد های توضیحات دیگر را نمایش نده",
        },
      },
      EDIT: {
        INDEX: {
          TITLE: "ویرایش فرصت شغلی",
          ACCESS_MESSAGE: ACCESS_MESSAGE,
        },
        STEP_ONE: {
          TITLE: "عنوان",
          JOB_CATEGORY: "دسته بندی شغلی",
          STATE_CITY: "استان / شهر",
          COOPERATION_TYPE: "نوع همکاری",
          MINIMUM_SALARY: "حداقل حقوق",
          RELATED_EXPERIENCE: "سابقه کار مرتبط",
          MINIMUM_DEGREE: "حداقل مدرک مورد نیاز",
          GENDER: "جنسیت",
          MILITARY_SERVICE_STATUS: "وضعیت خدمت سربازی",
          RESPONSIBILITIES_DESCRIPTION: "شرح وظایف و مسئولیت ها",
          SAVE_CHANGES: "ثبت تغییرات",
          CONTINUE: "ادامه",
          FEMALE: "زن",
          MALE: "مرد",
          BOTH: "هردو",
          NOT_SELECTED: "انتخاب نشده",
          ADDRESS: "محدوده محل کار",
          JOB_SUB_CATEGORY: "زیرگروه شغلی",
          EMPLOYER_DESCRIPTION: "توضیحات در پنل کارفرما",
          EMPLOYER_DESCRIPTION_TOOLTIP:
            "این توضیحات فقط برای دسته‌بندی بهتر شغل‌ها توسط کارفرماست و به کارجویان نمایش داده نمی‌شود",
        },
        STEP_TWO: {
          TITLE: "دسترسی افراد",
          FIRST_LAST_NAME: "نام و نام خانوادگی",
          SELECT: "جستجو و اضافه کردن کارمندان بر اساس نام",
          POSITION: "سمت",
          ACCESS_LEVEL: "سطح دسترسی",
          DELETE: "حذف",
          SAVE_CHANGES: "ثبت تغییرات",
          ACCESS_USER_MESSAGE: "شما به لیست اعضا دسترسی ندارید!",
          ACCESS_STEP_MESSAGE:
            "برای اعضای انتخاب شده حداقل یک سطح دسترسی الزامی است.",
          NOT_UPDATE_MEMBERS: "شما به ثبت تغییرات دسترسی ندارید.",
          GENERAL_JOB_DESCRIPTION:
            "همه اعضای سامانه به این فرصت شغلی دسترسی دارند.",
          ADD_NEW_ACCESS: "افزودن دسترسی جدید",
          MEMBER_COLLAPSE_TITLE:
            "افرادی که نقش آن‌ها «کاربر ارشد سامانه» است به همه‌ی فرصت‌های شغلی دسترسی دارند.",
          NOT_DELETE_SENIOR:
            "امکان حذف دسترسی افراد با نقش «کاربر ارشد سامانه» وجود ندارد.",
        },
        STEP_THREE: {
          TITLE: "مراحل استخدام",
          CUSTOM_STEP: "شخصی سازی مراحل",
          SAVE_CHANGES: "ثبت تغییرات",
          DELETE_MODAL_TXT: "آیا از حذف این مرحله اطمینان دارید؟",
          MOVED_RESUMES: "جابجایی رزومه‌ها",
          STEP: "مرحله",
          RESUMES: "رزومه‌های",
          TRANSFER_TO: "منتقل شود به",
          DRAG_DESCRIPTION:
            "با جابه جایی مراحل استخدام ترتیب دلخواه خود را مشخص کنید.",
          NO_ACCESS_MESSAGE: "شما به بخش ویرایش مراحل دسترسی ندارید!",
          TEMPLATE_DESCRIPTION:
            "با انتخاب یکی از قالب‌های زیر میتوانید مراحل را با استفاده از قالب مورد نظر شخصی سازی کنید.",
          MOVED_RESUMES_DESCRIPTION:
            "رزومه‌هایی که در مراحل قبلی وجود دارند را باید به یکی از مراحل جدید انتقال دهید.",
        },
        STEP_FOUR: {
          TITLE: "فرم رزومه",
          DEFAULT_RESUME:
            "استفاده از فرم رزومه پیش فرض ساخته شده در قسمت تنظیمات( شخصی سازی فرم رزومه پیش فرض )",
          CUSTOM_RESUME: "شخصی سازی فرم رزومه برای این فرصت شغلی",
          SAVE_CHANGES: "ثبت تغییرات",
          OTHER_DESCRIPTION: "هیچ کدام از فیلد های توضیحات دیگر را نمایش نده",
          ACCESS_MESSAGE: ACCESS_MESSAGE,
        },
      },
      INDEX: {
        ACTIVE_JOB_COUNT: "تعداد فرصت های شغلی فعال:",
        INACTIVE_JOB_COUNT: "غیر فعال:",
        CREATE_JOB_OPPORTUNITY_BTN: "ایجاد فرصت شغلی",
        LINK_COPY_BTN: "کپی لینک",
        SEARCH: "جستجوی نام فرصت شغلی",
        NO_DATA: "فرصت شغلی وجود ندارد!",
        HTML_COPY_BTN: " HTML کپی کد",
        LINK_COPY_TOOLTIP:
          "کارجویان با کلیک برروی این‌ لینک به صفحه حاوی لیست فرصت‌های شغلی فعال شما هدایت می شود و می‌توانند برای هرکدام که مایلند رزومه ثبت کنند",
        HTML_COPY_TOOLTIP:
          "این کد را در صفحه‌ی دلخواه از سایت خود کپی کنید. تا لیست فرصت‌های شغلی فعال شما در آن صفحه قرار بگیرد و کارجویان بتوانند برای هرکدام که تمایل دارند رزومه ارسال کنند.",
      },
      PUBLISHERS: {
        FREE: "رایگان",
        PRICE: "۳۰۰ هزار تومان",
        TITLE: "ویرایش انتشار‌دهنده‌های",
        PUBLISHERS: "انتشار‌دهنده‌ها",
        INSERT_TECHNOLOGY: "ثبت تکنولوژی",
        INSERT: "ثبت",
        MAIN_TECH: "تکنولوژی اصلی",
        JOB_BOARDS: "جاب بوردها",
        PUBLISHER_DATE: "تاریخ انتشار",
        STATUS: "وضعیت",
        UPDATE: "بروزرسانی",
        INTERN: "کارآموز (Intern)",
        JUNIOR: "جوان (Junior)",
        SENIOR: "ارشد (Senior)",
        MANAGER: "راهبر فنی (Lead)",
        LEVEL_PLACEHOLDER: "سطح فنی",
        TECHNOLOGY_LIST: "تکنولوژی‌های انتخاب شده",
        SHOW_TECH: "نمایش تکنولوژی‌ها",
        TECH_ERROR: "لطفا تکنولوژی را انتخاب کنید",
        TECHNOLOGY_TITLE_PLACEHOLDER:
          "عنوان تکنولوژی را تایپ و از لیست باز شده انتخاب کنید",
        TECHNOLOGY_MODAL_TITLE: "انتخاب تکنولوژی و سطح برای انتشار در کوئرا",
        TECHNOLOGY_MODAL_DESCRIPTION:
          "با کلیک بر روی تکنولوژی های انتخاب شده حداقل یک تکنولوژی را به عنوان تکنولوژی اصلی انتخاب کنید.",
        PUBLISHER_SITE: "صفحه اصلی وب‌سایت",
        PUBLISHER_JOBS_PAGE: "صفحه آگهی استخدام",
        PUBLISHER_RELEASE_CODITIONS: "شرایط انتشار آگهی",
        CANCEL_REQUEST: "لغو درخواست",
        PUBLISH_REQUEST: "درخواست انتشار آگهی",
        SENDED_REQUEST: "درخواست ارسال شده",
        NOT_HAVE_CONDITIONS_PUBLISH: "شرایط انتشار در این سایت را ندارید",
        SEARCH_IN_PUBLISHER_TITLE: "جستجو در سایت‌های انتشاردهنده",
        NO_DATA: "انتشاردهنده‌ای وجود ندارد",
        PUBLISHER_TERMS: "شرایط انتشاردهنده",
        NO_ACCESS_MESSAGE: ACCESS_MESSAGE,
        INTERN_REQUEST: "درخواست کارآموز",
        INTERN_MODAL_TITLE: "اعلام فرصت کارآموزی",
        COLLEGE: "دانشکده",
        FIELDS: "گرایش‌ها",
        GENDER: "جنسیت",
        CAPACITY: "ظرفیت",
        COMPANY_ID: "شناسه در دانشگاه صنعتی",
        COMPANY_ID_DESCRIPTION:
          "شناسه‌ی شرکت‌های عضو شهرک علمی و تحقیقاتی اصفهان همان شناسه ملی شرکت است.",
        PHONE_NUMBER: "شماره تماس",
        INTERN_COUNT: "تعداد کارآموز",
        PHNE_DESCRIPTION:
          "شماره تماس برای هماهنگی در اختیار دانشجویان قرار می‌گیرد",
        INVALID_NATIONAL_CODE: "شناسه ملی شرکت نامعتبر است",
        COMPANY_ID_IS_EMPTY: "شناسه ملی شرکت را وارد کنید",
        DESCRIPTION: "توضیحات",
        ESFAHAN_UNIVERSITY_TECHNOLOGY:
          "سامانه درخواست کارآموز دانشگاه صنعتی اصفهان",
        ACCEPT_BY_INTERVIEW: "پذیرش فقط با مصاحبه",
        REGISTERED: "ثبت شده",
        ACCEPT_BY_INTERVIEW_TOOLTIP:
          "اگر تمایل دارید قبل از پذیرش کارآموزان با آن‌ها مصاحبه و صلاحیت آنان را تأیید کنید، این گزینه را علامت بزنید. در غیر این صورت دانشگاه به انتخاب خود کارآموزان را به شما معرفی خواهد کرد.",
        SOHA_PUBLISH_DESCRIPTION:
          "با انتخاب این گزینه، آگهی استخدام در رسانه‌های استخدامی سها منتشر می‌شود و از طریق کانال‌های مختلف (مثل ایمیل و پیامک) به کارجویان مرتبط اطلاع‌رسانی خواهد شد.",
      },
      JOB_PIPELINE: {
        RESUME_REGISTER_BTN: "ثبت رزومه",
        MASS_RESUME_REGISTER_BTN: "آپلود انبوه رزومه",
        EDIT_BTN: "ویرایش",
        EXCEL_DOWNLOAD: "دانلود اکسل",
        PUBLISHER_BTN: "انتشار آگهی در {count} وبسایت",
        INTEGRATION_BTN: "یکپارچه سازی",
        DISABLE_BTN: "غیر فعال کردن",
        ENABLE_BTN: "فعال کردن",
        CONNECT_TO_EESTEKHTAM: "اتصال به ای‌استخدام",
        CONNECT_TO_JOBINJA: "اتصال به جابینجا",
        CONNECT_TO_JOBVISION: "اتصال به جاب‌ ویژن",
        UPDATE: "به‌روز رسانی لیست",
        RESUME_COUNT: "تعداد رزومه",
        NOT_ACTIVE_JOB_MESSAGE: "فرصت شغلی غیر فعال است!",
        ARCHIVE: "بایگانی(رزومه‌های رد شده)",
        BACK_TO_PIPELINE: "بازگشت به مراحل استخدام",
        ARCHIVE_BTN_DESCRIPTION:
          "برای رد کردن رزومه‌ها می‌توانید آنها را بکشید و اینجا رها کنید",
        BACK_TO_HIRING:
          "برای بازگشت رزومه‌ها به چرخه استخدام می توانید آنها را بکشید و اینجا رها کنید",
        NO_ARCHIVE_RESUME: "رزومه‌ای در بایگانی وجود ندارد.",
        UNKNOWN: "نامشخص",
        COLUMN_LAYOUT: "نمایش ستونی",
        ROW_LAYOUT: "نمایش ردیفی",
        PAGE_LAYOUT_DESCRIPTION: "برای تغییر چیدمان صفحه کلیک کنید",
        PRIVATE_EMAIL: "ایمیل اختصاصی",
        SOHA_PUBLISH_DESCRIPTION:
          "این آگهی در رسانه استخدامی سها منتشر نشده است، در صورت تمایل به انتشار آگهی و دریافت رزومه‌های بیشتر روی دکمه زیر کلیک کنید",
        INSERT_PUBLISH_REQUEST: "ثبت درخواست انتشار آگهی",
        BIRTHDAY:"تاریخ تولد",
        BIRTHDAY_FROM_YEAR:"سن از سال",
        BIRTHDAY_TO_YEAR:"سن تا سال",
        GENDER:"جنسیت",
        ADDRESS:"استان شهر",
        GRADE:"مقطع تحصیلی",
        FILTER:"فیلتر",
        REJECT_REASON: "دلایل رد کارجو",
      },
    },
    ROLES: {
      ROLES_LIST: {
        ROLES_MANAGEMENT: "مدیریت نقش",
        ADD_NEW_ROLE_BTN: "افزودن نقش جدید",
        DELETE_ALERT: "در صورت تایید، نقش از شرکت شما حذف خواهد شد",
        CHANG_USERS_ROLE: "تغییر نقش کاربران",
        USER_NEW_ROLE_SELECT_PLACEHOLDER: "نقش جدید",
        ROLE: "نقش",
        DELETE_MODAL_NEW_ROLE_DESCRIPTION:
          "به کاربران زیر اختصاص یافته است. برای این که این نقش را حذف کنید باید نقش جدید به کاربران اختصاص دهید.",
        DELETE_REASSIGN_ROLE_BUTTON: "انتقال و حذف نقش",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NO_ACCESS_TO_CREATE:
          "تعداد نقش‌ها به حداکثر مجاز در طرح شما رسیده است، لطفاً در صورت تمایل از طریق منوی «مالی» طرح خود را ارتقا دهید.",
      },
      ROLES_CREATE: {
        CREATE_ROLE: "ایجاد نقش",
        EDIT_ROLE: "ویرایش نقش",
        SHOW_ROLE: "نمایش نقش",
        ROLE_NAME_PLACEHOLDER: "نام نقش (اجباری)",
        ROLE_NAME_INPUT: "نام نقش",
        DESCRIPTION_PLACEHOLDER: "توضیحات",
        ACCESS: "دسترسی ها",
        REGISTER_ROLE: "ثبت نقش",
        EDIT_ROLE_BTN: "ثبت تغییرات",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
      },
      ROLES_EDIT: {
        CREATE_ROLE: "ایجاد نقش",
        ROLE_NAME_PLACEHOLDER: "نام نقش (اجباری)",
        ROLE_NAME_INPUT: "نام نقش",
        DESCRIPTION_PLACEHOLDER: "توضیحات",
        ACCESS: "دسترسی ها",
        EDIT_ROLE_BTN: "ثبت تغییرات",
      },
    },
    RECRUITMENT_REQUEST: {
      CREATE: {
        PAGE_TITLE: "افزودن درخواست جذب",
        SUBMIT_BTN_TEXT: "ثبت درخواست",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        JOB_TITLE_PLACEHOLDER: "عنوان شغل",
        PRIORITY_PLACEHOLDER: "اولویت درخواست",
        NUMBER_OF_EMPLOYERS_PLACEHOLDER: "تعداد نیرو",
        REASON_PLACEHOLDER: "علت درخواست",
        JOB_CATEGORY_PLACEHOLDER: "دسته بندی شغلی",
        COOPERATION_TYPE_PLACEHOLDER: "نوع همکاری",
        DESCRIPTION_PLACEHOLDER:
          "توضیحات (به مسئول بررسی درخواست نمایش داده میشود)",
        CITY_PLACEHOLDER: "استان/شهر",
        FLOW_PLACEHOLDER: "فرآیند درخواست",
        MINIMUM_SALARY_PLACEHOLDER: "حداقل حقوق",
        RELATED_WORK_EXPERIENCE: "سابقه کار مرتبط",
        MINIMUM_DEGREE_PLACEHOLDER: "حداقل مدرک مورد نیاز",
        GENDER_PLACEHOLDER: "جنسیت",
        MILITARY_SERVICE_PLACEHOLDER: "وضعیت خدمت سربازی",
        RESPONSIBILITIES_DESCRIPTION: "شرح وظایف و مسئولیت ها",
        NOT_SELECTED: "انتخاب نشده",
        JOB_SUB_CATEGORY: "زیرگروه شغلی",
        ADDRESS: "محدوده محل کار",
        NO_ACCESS_TO_CREATE:
          "در طرح فعال شما امکان ایجاد درخواست جذب وجود ندارد، لطفاً در صورت تمایل از طریق منوی «مالی» طرح خود را ارتقا دهید.",
      },
      INDEX: {
        PAGE_TITLE: "لیست درخواست‌های جذب",
        ORDER_BY_TXT: "وضعیت درخواست‌ها",
        BTN_TITLE: "افزودن درخواست جذب جدید",
        HEADER_TITLE: "عنوان",
        HEADER_USER: "درخواست دهنده",
        HEADER_NUMBER: "تعداد نیرو",
        HEADER_PRIORITY: "اولویت",
        HEADER_STATUS: "وضیعت",
        NOT_SELECTED: "انتخاب نشده",
        ALL_ITEMS: "همه‌ی موارد",
        WAITING_ITEMS: "منتظر بررسی",
        CONFIRM_ITEMS: "تایید شده",
        REJECT_ITEMS: "رد شده",
        DELAY_ITEMS: "تعویق افتاده",
        PUBLISH_ITEMS: "منتشر شده",
        CANCEL_ITEMS: "انصراف",
        WOMEN: "فقط زن",
        MEN: "فقط مرد",
        WOMEN_OR_MEN: "زن یا مرد",
        PERSON: "نفر",
        UNKNOWN: "نامشخص",
        UNKNOWN_POST: "سمت نامشخص",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NO_DATA: "درخواست جذب وجود ندارد.",
      },
      SHOW: {
        PERSON: "نفر",
        UNKNOWN_POST: "سمت نامشخص",
        RECRUITMENT_REQUEST_TITLE: "عنوان شغل",
        RECRUITMENT_INFO_TITLE: "جزئیات درخواست",
        RECRUITMENT_LOG_TITLE: "تاریخچه درخواست",
        PRIORITY: "اولویت درخواست",
        NUMBER_PERSON: "تعداد نیرو",
        JOB_CATEGORY: "دسته‌بندی شغلی",
        COOPERATION_TYPE: "نوع همکاری",
        CITY: "استان و شهر",
        CAUSE: "علت درخواست جذب نیرو",
        MINIMUM_SALARY: "حداقل حقوق",
        WORK_EXPERIENCE: "سابقه کار",
        MINIMUM_DEGREE: "حداقل مدرک تحصیلی",
        GENDER: "جنسیت",
        MILITARY_SERVICE: "وضعیت خدمت سربازی",
        JOB_ACTIVITY: "شرح آگهی استخدام",
        ACCEPT: "تایید",
        REJECT: "رد",
        LEVEL1: "کم",
        LEVEL2: "متوسط",
        LEVEL3: "فوری",
        LEVEL4: "خیلی فوری",
        DESCRIPTION_PLACEHOLDER: "توضیحات",
        DELAY_TIME: "زمان تعویق",
        CHANGE_STEP_FLOW: "تغییر مرحله فرآیند",
        CHANGE_STATUS: "تغییر وضعیت درخواست",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        GENDER_NOT_SELECTED: "جنسیت انتخاب نشده",
        WOMEN: "فقط زن",
        MEN: "فقط مرد",
        WOMEN_OR_MEN: "زن یا مرد",
        NO_MORE_LOG: "تاریخچه بیشتری وجود ندارد",
        NO_LOG: "تاریخچه وجود ندارد",
        JOB_SUB_CATEGORY: "زیرگروه شغلی",
        ADDRESS: "محدوده محل کار",
        FLOW_REQUEST: "فرآیند درخواست: {flowName}",
        INSERT_JOB: "ثبت فرصت شغلی",
        INSERT: "ثبت",
        CHANGE_STEP: "تغییر مرحله فرآیند",
        STEP_FLOW: "مرحله فرآیند",
        CHANGE_STATUS_TOOLTIP:
          " شما مسئول تأیید یا رد درخواست دراین مرحله نیستید. فقط «{approvers}» در این مرحله اجازه تأیید یا رد درخواست را دارند.",
      },
    },
    INVITATION: {
      INDEX: {
        PAGE_TITLE: "دعوت نامه های ارسال شده",
        ORDER_BY_TXT: "مرتب سازی براساس",
        SEARCH_BY_TXT: "براساس ایمیل/تلفن سمت نقش",
        NEWEST: "جدیدترین",
        INVITE_NEW_MEMBER: "دعوت عضو جدید",
        DELETE_MODAL_TXT: "آیا از حذف این دعوتنامه اطمینان دارید؟",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NO_DATA: "لیست دعوت نامه خالی است",
      },
      INVITATION_MEMBER: {
        TITLE: "دعوت همکار جدید",
        DESCRIPTION:
          "لینک دعوت می‌تواند از ‌طریق ایمیل یا پیامک ارسال شود لطفا آدرس ایمیل یا شماره تلفن همراه همکار جدید را وارد کنید.",
        USERNAME: "ایمیل یا شماره تلفن همراه",
        ROLE: "نقش",
        POST: "سمت (اختیاری)",
        SEND_LINK: "ارسال لینک",
        LAST_INVITATION: "آخرین دعوت نامه‌ها",
        SHOW_MORE: "مشاهده بیشتر",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        LAST_DAY: "روز قبل",
        TODAY: "امروز",
        RESUME_REVIEWER_EXPERT: "کارشناس بررسی رزومه",
      },
    },
    MEMBER: {
      INDEX: {
        PAGE_TITLE: "لیست همکاران",
        ORDER_BY_TXT: "مرتب سازی براساس",
        SEARCH_BY_TXT: "بر اساس نام, سمت یا نقش",
        NEWEST: "جدیدترین",
        INVITE_NEW_MEMBER: "دعوت همکار جدید",
        DELETE_MODAL_TXT: "آیا از حذف این کاربر اطمینان دارید؟",
        USER_NAME_PLACEHOLDER: "آدرس ایمیل یا تلفن همراه",
        ROLE_PLACEHOLDER: "نقش",
        POST_PLACEHOLDER: "سمت (اختیاری)",
        PERSONNEL_CODE_PLACEHOLDER: "کد پرسنلی (اختیاری)",
        SEND_LINK: "ارسال لینک",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        INVITE_MEMBER_MODAL_TITLE:
          "لینک دعوت میتواند از طریق ایمیل یا پیامک ارسال شود.<br> لطفا ادرس ایمیل یا شماره تلفن همراه همکار جدید را وارد کنید",
        ASSIGN_JOBS_MODAL_TITLE: "تعیین دسترسی شغل",
        MEMBERS: "کاربران",
        MEMBER: "کاربر",
        ASSIGN_JOBS: "تغییر دسترسی و حذف کاربر",
        INSERT_NEW_MEMBER: "افزودن همکار جدید",
        INSERT_MEMBER_MODAL_TITLE:
          "اطلاعات ورود کاربر به سامانه<br>نام کاربری: ایمیل یا موبایل<br>کلمه عبور: کد پرسنلی",
        INSERT: "افزودن",
        FIRST_NAME: "نام",
        LAST_NAME: "نام خانوادگی",
        MOBILE: "موبایل",
        EMAIL: "ایمیل",
        GET_MEMBER_INFO: "دریافت اطلاعات همکار",
        PERSONNEL_CODE: "کد پرسنلی",
      },
    },
    RESUME: {
      RESUME_DETAIL: {
        TABS: {
          NOTES: {
            INSERT_NOTE: "ثبت یادداشت",
            NOTE_TEXT: "متن یادداشت",
            NO_MORE_NOTE: "یادداشت بیشتری وجود ندارد",
            NO_NOTE: "یادداشت وجود ندارد",
            EDIT: "ویرایش",
            EDIT_NOTE: "ویرایش یادداشت",
            GUEST_USER: "کاربر مهمان",
            SYSTEM: "سیستم",
            NOT_ACTIVE_JOB_MESSAGE: "فرصت شغلی غیر فعال است!",
            PRINT: "چاپ",
          },
          LOGS: {
            NO_MORE_LOG: "تاریخچه بیشتری وجود ندارد",
            NO_LOG: "تاریخچه وجود ندارد",
            SYSTEM: "سیستم",
            FILTER_SYSTEM_LOG: "تاریخچه‌های سیستم را نشان نده",
            PRINT: "چاپ",
            ACCESS_MESSAGE: ACCESS_MESSAGE,
          },
          SCORING_CARD: {
            TITLE: "فرم‌های ثبت شده برای رزومه",
            AVERAGE_SCORE: "میانگین",
            INSERT_CARD: "ثبت فرم ارزیابی‌ (کارت امتیاز‌دهی)",
            INSERT_SCORE: "ثبت نمره",
            SCORING_CARD: "فرم ارزیابی (کارت امتیازدهی)",
            INSERT: "ثبت",
            NO_ROLE: "سمت نامشخص",
            SCORE: "نمره",
            DESCRIPTION: "توضیحات",
            LOAD_MORE: "مشاهده بیشتر",
            CLOSE: "بستن",
            FROM_TWENTY: "( از ۲۰ )",
            ACCESS_MESSAGE: ACCESS_MESSAGE,
            MAXIMUM_NUMBER_ERROR: "نمره وارد شده بیشتر از ۲۰ است",
            NO_DATA: "فرم ارزیابی برای رزومه ثبت نشده است!",
            NOT_ACTIVE_JOB_MESSAGE: "فرصت شغلی غیر فعال است!",
            NO_SCORE: "نمره‌ای برای شایستگی ثبت نشده است",
            ADD_SCORING_CARD: "الصاق فرم ارزیابی",
            COMPETENCIES: "شایستگی‌‌ها",
            WEIGHT: "ضریب",
            SCORING: "نمره دهی",
            DELETE_MODAL_TXT: "آیا از حذف کارت رزومه اطمینان دارید؟",
            SCORING_GUID: "راهنمای نمره‌دهی",
            PRINT: "چاپ",
          },
          FILES: {
            NO_MORE_FILE: "فایل بیشتری وجود ندارد",
            NO_FILE: "فایل وجود ندارد",
            DRAG_AND_DROP_FILE:
              "فایل‌ انتخاب شده را داخل باکس کشیده و رها کنید یا",
            HERE: "اینجا",
            OTHER: "سایر",
            FILE: "فایل",
            SEND: "ارسال شد",
            CLICKED: "کلیک کنید",
            FILE_TYPE: "نوع فایل: {type}",
            DOWNLOAD: "دانلود",
            DELETE: "حذف",
            SHOW: "نمایش",
            FILE_BY: "فایل توسط",
            ATTACHED: "پیوست شد.",
            INSERT_FILE_TITLE: "ثبت اطلاعات فایل",
            SEND_FILE: "ارسال فایل",
            FILE_NAME: "نام فایل",
            FILE_TOAST_ERROR_TEXT: "برای بارگذاری فقط یک فایل رها کنید",
            FORMAT_FILE_ERROR: "لطفا یک تصویر, pdf, word یا excel انتخاب کنید",
            SIZE_FILE_ERROR: "حداکثر اندازه فایل ۲۰ مگابایت است",
            NOT_SHOW_MESSAGE: "این نوع فایل در مرورگر قابل نمایش نیست!",
            USER_FILE: "فایل ضمیمه شده توسط کاربر",
            ACCESS_MESSAGE: ACCESS_MESSAGE,
            NOT_ACTIVE_JOB_MESSAGE: "فرصت شغلی غیر فعال است!",
            BIRTH_CERTIFICATE_IMAGE: "تصویر شناسنامه",
            LAST_DEGREE_IMAGE: "تصویر آخرین مدرک تحصیلی",
            MILITARY_SERVICE_IMAGE: "تصویر کارت پایان خدمت",
            NATIONAL_CARD_IMAGE: "تصویر کارت ملی",
            SHOW_FILE: "نمایش فایل",
            USER_SENDED_FILE: "فایل‌های ارسال شده توسط کارجو",
            RESUME_FILE: "فایل رزومه",
            EMPLOYER_ATTACHED_FILE: "فایل‌های الصاق شده توسط همکاران",
            ATTACHED_BY: "الصاق شده توسط"
          },
          TESTS: {
            TITLE: "پرسشنامه‌های رزومه",
            PERSONALITY: "شخصیت شناسی",
            ALL: "همه",
            NO_SEND: "ارسال نشده",
            SENT: "ارسال شده",
            ATTACH: "الصاق",
            NO_ANSWER: "پاسخ داده نشده",
            ANSWERED: "پاسخ داده شده",
            SHOW_ANSWER: "مشاهده پاسخ",
            SHOW_ANSWER_CORRECTION: "مشاهده پاسخ و ثبت نمره",
            MODAL_ATTACH_TEST_TITLE: "الصاق پرسشنامه",
            PERIOD_TIME: "مهلت انجام(روز)",
            TIME: "زمان",
            SEARCH: "جستجو",
            TEST: "پرسشنامه",
            NO_DATA: "پرسشنامه‌ای به رزومه الصاق نشده است.",
            EXPIRED_TOOLTIP: "مهلت پاسخ کارجو به پایان رسیده است.",
            NOT_ACTIVE_JOB_MESSAGE: "فرصت شغلی غیر فعال است!",
            COPY_LINK: "کپی لینک",
            SET_MESSAGE: "انتخاب الگوی پیام",
            MESSAGE_PATTERN: "الگوی پیام",
            SEND_LINK:
              "لینک پرسشنامه از طریق ایمیل و پیامک به کارجو ارسال شود.",
            NO_PUBLIC_TEST:
              "در طرح فعال شما امکان ارسال پرسشنامه‌های شخصیت‌شناسی وجود ندارد، لطفاً در صورت تمایل از طریق منوی «مالی» طرح خود را ارتقا دهید.",
            MESSAGE_PATTERN_TEXT: "متن الگو",
            MESSAGE_PATTERN_ERROR:
              "الگوی پیام انتخابی باید شامل موارد زیر باشد: <br> -عنوان پرسشنامه <br> -مهلت پاسخگویی به پرسشنامه <br> -لینک پرسشنامه <br> با استفاده از افزودن الگوی جدید در گزینه‌ها می توانید الگوی جدید بسازید در غیر اینصورت الگوی پیش فرض سامانه را انتخاب کنید.",
            PRINT: "چاپ",
          },
          CHECK_LIST: {
            TITLE: "چک‌ لیست‌های رزومه",
            NAME: "نام چک‌لیست",
            ACCESS_MESSAGE: ACCESS_MESSAGE,
            STEP: "مرحله",
            ITEMS: "آیتم‌ها",
            NO_DATA: "چک‌لیست برای رزومه ثبت نشده است!",
            INSERT_CHECK_LIST: "افزودن چک‌لیست",
            INSERT: "ثبت",
            CHECK_LIST: "چک‌لیست‌",
            DELETE_MODAL_TXT: "آیا از حذف این چک‌لیست اطمینان دارید؟",
            NOT_ACTIVE_JOB_MESSAGE: "فرصت شغلی غیر فعال است!",
            PRINT: "چاپ",
          },
          TASKS: {
            TITLE: "وظایف ثبت شده برای رزومه",
            INSERT_TASK: "ثبت وظیفه",
            INSERT: "ثبت",
            DESCRIPTION: "توضیحات",
            ACCESS_MESSAGE: ACCESS_MESSAGE,
            NO_DATA: "وظیفه‌ای برای رزومه ثبت نشده است!",
            NOT_ACTIVE_JOB_MESSAGE: "فرصت شغلی غیر فعال است!",
            ADD_TASK: "ثبت وظیفه",
            DUE_AT: "تاریخ انجام",
            TASK_TYPE: "نوع وظیفه",
            EMPLOYEE: "همکار",
            TASK_TIME: "مهلت انجام",
            REFERRAL_TO: "ارجاع به",
            STATUS: "وضعیت",
            INSERT_NOTE: "ثبت یادداشت",
            NOTE_TEXT: "متن یادداشت",
            NOTES: "یادداشت‌ها",
            TASK_DONE_TIME: "تاریخ انجام",
            DONE: "انجام شده",
            NOT_YOUR_TASK: "وظیفه مربوط به شما نیست.",
            PRINT: "چاپ",
          },
        },
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        EDIT: "ویرایش",
        DELETE: "حذف",
        GUEST_EXPERT: "ارسال به کارشناس مهمان",
        SEND_EMAIL_SMS: "ارسال پیامک و ایمیل",
        SEND_TO_ARCHIVE: "انتقال به بایگانی",
        SEND_TO_ARCHIVE_TOOLTIP: "رد صلاحیت در این مرحله و انتقال رزومه به پوشه بایگانی",
        ADD_TAG: "افزودن برچسب",
        JOB_OPPORTUNITY: "فرصت شغلی",
        STEP: "مرحله استخدام",
        EMPLOYEE: "مسئول بررسی",
        CHANGE_JOB: "انتقال رزومه به فرصت شغلی دیگر",
        CHANGE_STEP: "انتقال رزومه به مرحله استخدام دیگر",
        CHANGE_EMPLOYEE: "انتخاب مسئول بررسی",
        INSERT: "ثبت",
        SPECS: "مشخصات",
        NOTES: "یادداشت‌ها",
        FILES: "فایل‌های ضمیمه",
        HISTORY: "تاریخچه",
        SCORING_CARD: "فرم ارزیابی",
        EXAMS: "پرسشنامه‌ها",
        SENT_MESSAGES: "پیام‌های ارسال شده",
        CHECK_LIST: "چک‌لیست",
        TASKS: "وظایف",
        ANSWER_TEST: "پاسخ آزمون",
        DELETE_RESUME_TXT: "آیا از حذف این رزومه اطمینان دارید؟",
        DELETE_INTERVIEW_TXT: "آیا از لغو تاریخ مصاحبه اطمینان دارید؟",
        NOT_SELECTED: "انتخاب نشده",
        ARCHIVE: "بایگانی",
        SET_INTERVIEW_TIME: "تنظیم زمان مصاحبه",
        SET_NEW_TIME: "تنظیم زمان جدید",
        INTERVIEW_DATE: "تاریخ مصاحبه",
        ADD_TO_GOOGOLE_CALENDAR: "افزودن به تقویم گوگل",
        CANCEL_INTERVIEW_DATE: "لغو زمان مصاحبه",
        DELETE_BTN_TXT: "بله، حذف شود",
        CANCEL_BTN_TXT: "بله، لغو شود",
        NEXT_LEVEL: "تأیید و مرحله بعد",
        NEXT_LEVEL_TOOLTIP: "تأیید رزومه و ارتقای کارجو به مرحله بعدی استخدام",
        NEXT_RESUME: "رزومه بعدی",
        PREVIOUS_RESUME: "رزومه قبلی",
        BACK: "بازگشت",
        UP: "بالای صفحه",
        QR_CODE: "کد QR",
        SEND_MESSAGE_BY_TELEGRAM: "ارسال پیام در تلگرام",
        SEND_MESSAGE_BY_WEB_WHATSAPP: "ارسال پیام در واتس‌آپ وب",
        SEND_MESSAGE_BY_WHATSAPP: "ارسال پیام در واتس‌آپ",
        CALL: "برقرای تماس تلفنی",
        SEND_SMS: "ارسال پیامک",
        SEND_EMAIL: "ارسال ایمیل",
        SAVE_TO_CONTACT: "ذخیره در مخاطبین",
        QR_MODAL_SCAN: "کد QR",
        QR_MODAL_CREATE: "برای ساخت کد QR یکی از گزینه‌ها را انتخاب کنید",
        QR_MODAL_DESCRIPTION: "برای {key} کد زیر را اسکن کنید",
        NOT_ACTIVE_JOB_MESSAGE: "فرصت شغلی غیر فعال است!",
        RESUME_COPY: "کپی رزومه",
        RESUME_PRINT: "چاپ رزومه",
        RESUME_TOOLS: "ابزارهای رزومه",
        COPY: "کپی",
        COMPANY: "شرکت",
        INSERT_NOTE: "ثبت یادداشت",
        CANCEL_EDIT: "پایان ویرایش",
        REJECT_REASON: "دلایل رد کارجو",
        TAGS: "برچسب‌ها",
        MOBILE: "تلفن همراه",
        EMAIL: "ایمیل",
        INTERVIEW_SCORE: "نمره نهایی مصاحبه",
        TEST_SCORE: "نمره نهایی آزمون",
        AVERAGE_SCORE: "میانگین وزنی",
      },
      RESUME_ASSIGN: {
        PAGE_TITLE: "لیست رزومه‌های ارجاع شده به شما",
        NO_DATA: "رزومه‌ای به شما ارجاع نشده است!",
        ALL: "همه",
      },
      MASS_UPLOAD: {
        PAGE_TITLE: "آپلود انبوه رزومه",
        DESCRIPTION:
          "در این قسمت با آپلود دسته ای رزومه ی کارجویان قادر خواهید بود اطلاعات آنها شامل ایمیل، موبایل و نام را وارد سیستم کنید.",
        DRAG_AND_DROP_FILE: "فایل‌ خود را داخل باکس کشیده و رها کنید یا",
        HERE: "اینجا",
        CLICKED: "کلیک کنید",
        NAME_PLACEHOLDER: "نام",
        FAMILY_PLACEHOLDER: "نام خانوادگی",
        PHONE_PLACEHOLDER: "شماره موبایل",
        EMAIL_PLACEHOLDER: "ایمیل",
        FILE_NAME: "نام فایل:",
        CLOSE_FILE: "بستن",
        SHOW_FILE: "نمایش فایل",
        SUBMIT_FINAL_RESUMES: "ثبت نهایی رزومه ها",
        REMOVE_PREVIOUS_RESUMES:
          "رزومه‌هایی که قبلا آپلود کرده‌اید هنوز ثبت نشده‌اند. در صورت آپلود فایل جدید رزومه‌های ثبت نشده‌ی قبلی حذف می‌شوند. می‌توانید ادامه دهید یا انصراف دهید و رزومه‌های قبلی را ثبت نهایی کنید",
        PDF_TYPE_ERROR: "نوع فایل حتما باید pdf باشد",
        NAME_ERROR: "نام را وارد کنید",
        FAMILY_ERROR: "نام خانوادگی را وارد کنید",
        PHONE_ERROR: "موبایل معتبر وارد کنید",
        EMAIL_ERROR: "ایمیل معتبر وارد کنید",
        SUBMITTED_SUCCESSFULLY:
          "همه رزومه ها با موفقیت ثبت شدند. در حال انتقال به صفحه فرایند استخدام ...",
        ARE_YOU_SURE_TO_EXIT:
          "از خروج این صفحه مطمئن هستید؟ شما رزومه های ثبت نشده دارید",
        RETURN_BTN_TXT: "ادامه",
        CANCEL_BTN_TXT: "انصراف",
        FAST_UPLOAD_WITHOUT_EXTRACT_TEXT:
          "آپلود سریع، بدون استخراج اطلاعات رزومه",
      },
      RESUME_SEARCH: {
        PAGE_TITLE: "لیست رزومه‌ها",
        NO_DATA: "موردی یافت نشد!",
      },
      RESUME_DETAIL_FOR_GUEST: {
        MR: "آقای",
        MS: "خانم",
        ADD_NOTE: "افزودن یادداشت",
      },
    },
    SETTING: {
      EDIT_USER: {
        FIRST_NAME: "نام",
        LAST_NAME: "نام خانوادگی",
        MOBILE: "تلفن همراه",
        EMAIL: "ایمیل",
        GENDER: "جنسیت",
        EDIT_USER_INFO: "ویرایش اطلاعات",
        CHANGE_PASSWORD: "تغییر کلمه عبور",
        OLD_PASSWORD: "کلمه عبور فعلی",
        PASSWORD: "کلمه عبور جدید",
        PASSWORD_REPEAT: "تکرار کلمه عبور",
        FEMALE: "زن",
        MALE: "مرد",
        NOT_SELECTED: "انتخاب نشده",
        REPEAT_PASS_ERROR: "تکرار رمز را به صورت صحیح وارد کنید",
        FORMAT_IMAGE_ERROR: "فرمت تصویر نامعتبر است!",
        SIZE_IMAGE_ERROR: "حداکثر اندازه عکس ۵۰۰ کیلوبایت است",
      },
      EDIT_COMPANY: {
        EDIT_COMPANY: "ویرایش شرکت",
        COMPANY_NAME: "نام شرکت",
        WEB_SITE: "وب سایت",
        JOB_FIELD: "زمینه کاری",
        CITY: "شهر و استان",
        NUMBER_EMPLOYEE: "تعداد کارمندان",
        PHONE: "تلفن",
        DATE_ESTABLISHMENT: "تاریخ تاسیس",
        ADDRESS: "آدرس",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NOT_SELECTED: "انتخاب نشده",
        CRROPPED_IMAGE: "برش تصویر",
        UPLOAD_NEW_LOGO: "بارگذاری لوگوی جدید",
        UPLOAD_LOGO: "بارگذاری لوگو",
      },
      CUSTOMIZE_RESUME_FORM: {
        INSERT: "ثبت فرم",
        EDIT: "ویرایش",
        NAME: "نام فرم",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        EDIT_FORM: "ویرایش فرم رزومه",
        CREATE_FORM: "ایجاد فرم رزومه",
        FORM_DESCRIPTION:
          "با استفاده فرم ساز زیر فرم مورد نظر خود برای دریافت رزومه را بسازید",
      },
      RESUME_FORM: {
        PAGE_TITLE: "فرم‌های ثبت رزومه",
        PAGE_DESCRIPTION:
          "در این بخش شما می توانید فرم‌های مختلفی برای ثبت رزومه ایجاد کنید. برای ایجاد فرم جدید بر روی افزودن کلیک کنید.",
        ADD: "افزودن",
        DELETE_FORM: "آیا از حذف فرم اطمینان دارید؟",
        EDIT_BTN: "ویرایش",
        DELETE_BTN: "حذف",
        TYPE: "نوع",
        CREATOR: "ایجاد کننده",
        NAME: "نام",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        COPY: "ایجاد کپی",
        SELECT_REPLACE_FORM: "انتخاب فرم جایگزین",
        REPLACE_FORM: "فرم‌ جایگزین",
        REPLACE_FORM_DESCRIPTION:
          "فرم شما قبلا به فرصت شغلی متصل شده است. <br> اگر همچنان مایل به حذف فرم هستید یک فرم جایگزین انتخاب کنید",
        CANCEL: "انصراف",
      },
      CUSTOMIZE_STEP: {
        TITLE: "شخصی سازی مراحل",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NAME: "نام",
        COPY: "ایجاد کپی",
        EDIT_BTN: "ویرایش",
        DELETE_BTN: "حذف",
        USER: "کاربر ایجاد کننده",
        ADD: "افزودن",
        DELETE_MODAL_TXT: "آیا از حذف این مرحله اطمینان دارید؟",
        DELETE_TEMPLATE_TXT: "آیا از حذف این قالب اطمینان دارید؟",
        DRAG_DESCRIPTION:
          "با جابه جایی مراحل استخدام ترتیب دلخواه خود را مشخص کنید.",
        NO_ACCESS_MESSAGE:
          "شما به بخش ویرایش مراحل دسترسی ندارید! مراحل پیش فرض شرکت برای این شغل اعمال خواهد شد.",
      },
      MANAGE_STEP: {
        INSERT_STEPS: "ایجاد قالب جدید",
        EDIT_STEPS: "ویرایش قالب",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NAME: "نام قالب",
        INSERT: "ثبت",
        EDIT: "ویرایش",
      },
      INTEGRATION_JOB_BOARD: {
        TITLE: "منابع دریافت رزومه",
        USERNAME_IN: "نام کاربری شما در {jobBoard}",
        USERNAME: "نام کاربری",
        PASSWORD_IN: "رمز عبور شما در {jobBoard}",
        PASSWORD: "رمز عبور",
        INSERT: "ثبت",
        API_KEY: "API Key",
        QUERA: "‌Quera‌|کوئرا",
        STATUS: "وضعیت حساب",
        DELETE: "حذف حساب کاربری",
        INVALID: "نام کاربری یا رمز ورود اشتباه است.",
        ACTIVE: "حساب کاربری فعال است.",
        PENDING: "در حال بررسی وضعیت حساب...",
        UPDATE_PASSWORD: "ویرایش کلمه عبور",
        ADD_NEW_CONNECTION: "ایجاد اتصال جدید",
        ADD_NEW_CONNECT_TO: "ایجاد اتصال جدید به {jobBoard}",
        EDIT_CONNECT_TO: "ویرایش اتصال به {jobBoard}",
        E_ESTEKHTAM: "ای‌اسـتخـدام",
        JOB_VISION: "جـاب ویـژن",
        JABINJA: "جـابـیـنـجـا",
        CONNECT_TO_YOUR_WEB_SITE: "اتصال به وبسایت شرکت شما",
        CONNECT_TO_WEB_SITE_DESCRIPTION:
          "برای نمایش فرصت‌های شغلی و فرم‌های دریافت رزومه در سایت شرکت، کد زیر را کپی کنید و در صفحه فرصت‌های شغلی وبسایت خود قرار دهید.",
        BACK: "بازگشت",
        DELETE_MODAL_TXT: "آیا از حذف ارتباط جاب‌بورد اطمینان دارید؟",
        HTML_COPY_BTN: "کپی کد HTML",
        EDIT: "ویرایش",
        NO_DATA: "اتصال وجود ندارد.",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        BEFORE_CARD: "نوار کناری",
        TEXT: "متن",
        ICONS: "آیکون‌‌ها",
        BUTTON: "دکمه",
        BUTTON_TEXT: "متن دکمه",
        CATEGORY_TAG_BACKGROUND: "برچسب دسته‌بندی",
        CATEGORY_TAG_TEXT: "متن برچسب دسته‌بندی",
        BORDER: "حاشیه",
        FORM: "فرم درخواست",
        SELECT_COLOR: "انتخاب رنگ بخش‌های مختلف",
      },
      NOTIFICATION: {
        PAGE_TITLE: "تنظیمات اطلاع رسانی",
        PUBLIC_NOTIFICATION: "اطلاع رسانی کلی",
        JOB_NOTIFICATION: "اطلاع رسانی فرصت شغلی",
        INSERT_CHANGE: "ثبت تغییرات",
        ADD_JOB: "افزودن فرصت شغلی",
        JOB: "فرصت شغلی",
        SYSTEM: "سامانه",
        EMAIL: "ایمیل",
        SMS: "پیامک",
      },
      MESSAGE_PATTERN: {
        PAGE_TITLE: "الگو‌های پیام",
        PAGE_DESCRIPTION:
          "در این بخش شما می توانید الگو‌های پیام که در بخش های مختلف سامانه برای کاربر ارسال می شود را تنظیم کنید. برای ایجاد الگوی جدید بر روی افزودن الگوی پیام کلیک کنید.",

        DELETE_MESSAGE: "آیا از حذف الگوی پیام اطمینان دارید؟",
        EDIT_BTN: "ویرایش",
        DELETE_BTN: "حذف",
        TYPE: "نوع",
        NAME: "نام الگوی پیام",
        WELCOME_ERROR:
          "برای خوش آمدگویی فقط یک پیام میتوانید ثبت کنید در صورت تغییر متن پیام قبلی را ویرایش کنید",
        NO_ACCESS_TO_CREATE:
          "تعداد الگوهای پیام به حداکثر مجاز در طرح شما رسیده است، لطفاً در صورت تمایل از طریق منوی «مالی» طرح خود را ارتقا دهید.",
        PREVIEW: "پیش نمایش",
        NO_DATA: "الگوی پیام وجود ندارد.",
        COPY: "ایجاد کپی",
        ADD_MESSAGE: "افزودن الگوی پیام",
      },
      CUSTOM_TEST: {
        PAGE_TITLE: "پرسشنامه‌ها",
        PAGE_DESCRIPTION:
          "در این بخش شما می توانید پرسشنامه‌های شخصی که برای کاربر ارسال می شود را تنظیم کنید. برای ایجاد پرسشنامه جدید بر روی افزودن کلیک کنید.",
        ADD: "افزودن",
        DELETE_TEST: "آیا از حذف پرسشنامه اطمینان دارید؟",
        EDIT_BTN: "ویرایش",
        DELETE_BTN: "حذف",
        TYPE: "نوع",
        DESCRIPTION: "توضیحات",
        NAME: "نام",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NO_ACCESS_TO_CREATE:
          "تعداد پرسشنامه‌ها به حداکثر مجاز در طرح شما رسیده است، لطفاً در صورت تمایل از طریق منوی «مالی» طرح خود را ارتقا دهید.",
        NO_DATA: "پرسشنامه وجود ندارد.",
        COPY: "ایجاد کپی",
      },
      CHECK_LIST: {
        PAGE_TITLE: "چک‌لیست‌‌ها",
        PAGE_DESCRIPTION:
          "در این بخش شما می توانید چک‌لیست هایی که در مرحله چک‌لیست استفاده می شود را تنظیم کنید. برای ایجاد چک‌لیست جدید بر روی افزودن چک‌لیست کلیک کنید.",
        ADD: "افزودن",
        DELETE_CHECK_LIST: "آیا از حذف چک‌لیست اطمینان دارید؟",
        EDIT_BTN: "ویرایش",
        DELETE_BTN: "حذف",
        TYPE: "نوع",
        DESCRIPTION: "توضیحات",
        NAME: "نام",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NOT_CREATE_CHECK_LIST:
          "تعداد چک‌لیست‌ها به حداکثر مجاز در طرح شما رسیده است، لطفاً در صورت تمایل از طریق منوی «مالی» طرح خود را ارتقا دهید.",
        NO_DATA: "چک‌لیست وجود ندارد.",
        COPY: "ایجاد کپی",
      },
      REJECT_REASON: {
        PAGE_TITLE: "علت های رد کارجو",
        NAME: "نام",
        DELETE_BTN: "حذف",
        INSERT: "ثبت",
        REASON_LIST: "لیست علت‌ها",
        ADD_REJECT_REASON: "افزودن علت رد",
        DELETE_REASON: "آیا از حذف علت رد اطمینان دارید؟",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        DESCRIPTION: "توضیحات",
        ADD: "افزودن",
      },
      CREATE_EDIT_CUSTOM_TEST: {
        EDIT_PAGE_TITLE: "ویرایش آزمون",
        CREATE_PAGE_TITLE: "ایجاد آزمون",
        NAME: "نام",
        TIME_PLACEHOLDER: "زمان(براساس دقیقه)",
        TIME: "زمان",
        DESCRIPTION: "توضیحات",
        ADD_QUESTION: "افزودن سوال",
        EDIT_QUESTION: "افزودن سوال",
        ADD_ITEM: "افزودن گزینه",
        EDIT: "ویرایش",
        INSERT: "افزودن",
        CREATE: "ایجاد",
        DELETE: "حذف",
        TYPE: "نوع",
        SCORE: "نمره",
        TITLE: "عنوان",
        ITEM: "گزینه",
        ITEMS: "گزینه‌ها",
        QUESTION_NAME_ERROR: "لطفا عنوان سوال را وارد کنید",
        CHECKBOX: "گزینه چند انتخابی",
        RADIO_BUTTON: "گزینه تک انتخابی",
        DESCRIPTIVE: "تشریحی",
        SCORE_TITLE: "عنوان سوال",
        QUESTIONS_TEST: "سوالات آزمون",
        EMPTY_QUESTION_LIST: "لیست سوالات خالی است",
        GO_UP: "حرکت به بالا",
        GO_DOWN: "حرکت به پایین",
      },
      CREATE_EDIT_CHECK_LIST: {
        EDIT_PAGE_TITLE: "ویرایش چک ‌لیست",
        CREATE_PAGE_TITLE: "ایجاد چک ‌لیست",
        DESCRIPTION: "توضیحات",
        EDIT_ITEM: "ویرایش گزینه",
        ADD_ITEM: "افزودن گزینه",
        EDIT: "ویرایش",
        INSERT: "افزودن",
        CREATE: "ایجاد",
        DELETE: "حذف",
        TYPE: "نوع",
        TITLE: "عنوان",
        ITEM: "گزینه",
        ITEMS: "گزینه‌ها",
        EMPTY_ITEMS_LIST: "لیست گزینه‌ها خالی است",
        ITEMS_CHECK_LIST: "آیتم‌های چک‌لیست",
      },
      LINKED_ID: {
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        PAGE_TITLE: "لینک شناسه‌دار",
        DELETE_MESSAGE: "آیا از حذف لینک اطمینان دارید؟",
        PAGE_DESCRIPTION: `در این بخش می‌توانید شناسه‌های مخصوص خودتان را بسازید و لینک مربوط به
          فرم دریافت رزومه برای هر فرصت شغلی را با این شناسه‌ی خاص کپی کنید تا
          توسط اشخاص مختلف در جاهای مختلف منتشر شوند. از این پس وقتی به بخش آمار
          در پنل کاربری خود مراجعه کنید، می‌توانید مشاهده کنید که چند نفر از
          طریق لینک‌های با این شناسه‌ی خاص وارد فرم ثبت رزومه شده‌اند و چند نفر
          از آن‌ها رزومه‌ی خود را ثبت کرده‌اند. مثلاٌ اگر برای هر کارمند شرکت
          خود یک شناسه بسازید تا از طریق لینک شناسه‌دار، آگهی استخدام را در
          شبکه‌های اجتماعی خود منتشر کند؛ این که هر کارمند شما موفق شده چند
          کارجو را جذب کند برایتان قابل مشاهده خواهد بود.`,
        NO_DATA: "هنوز لینکی نساخته‌اید",
        ID: "شناسه",
        ID_NAME: "نام شناسه",
        DELETE: "حذف",
        JOBS: "فرصت شغلی",
        SELECT_JOB: "فرصت شغلی را انتخاب کنید",
        DESCRIPTION: "توضیحات",
        MODAL_TITLE: "انتخاب اسم شناسه",
        CREATE_LINK: "ایجاد لینک شناسه دار",
        COPY_LINK_SUCCESS: "لینک با موفقیت کپی شد",
      },
      COMPETENCIES: {
        PAGE_TITLE: "شایستگی / معیارها",
        NAME: "نام",
        DELETE_BTN: "حذف",
        INSERT: "ثبت",
        COMPETENCIES_LIST: "لیست شایستگی‌ها",
        ADD_COMPETENCIES: "افزودن شایستگی",
        DELETE_COMPETENCY: "آیا از حذف علت رد اطمینان دارید؟",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        DESCRIPTION: "توضیحات",
        ADD: "افزودن",
        ADD_MORE: "مشاهده بیشتر",
        CLOSE: "بستن",
      },
      SCORING_CARD: {
        PAGE_TITLE: "فرم‌های ارزیابی (کارت‌های امتیازدهی)",
        PAGE_DESCRIPTION:
          "در این بخش می‌توانید فرم‌های ارزیابی را بر اساس معیارهای مختلف ایجاد کنید و پس از این که کارت‌ها را به رزومه‌ای الصاق کنید، همکاران شما می‌توانند مطابق معیارهایی که در کارت تعریف شده، کارجویان را ارزیابی و نمره‌دهی کنند.",
        ADD: "افزودن",
        DELETE_CARD: "آیا از حذف کارت اطمینان دارید؟",
        EDIT_BTN: "ویرایش",
        DELETE_BTN: "حذف",
        TYPE: "نوع",
        DESCRIPTION: "توضیحات",
        NAME: "نام",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NO_DATA: "فرم ارزیابی وجود ندارد.",
        NO_ACCESS_TO_CREATE:
          "تعداد فرم‌های ارزیابی به حداکثر مجاز در طرح شما رسیده است، لطفاً در صورت تمایل از طریق منوی «مالی» طرح خود را ارتقا دهید.",
        COPY: "ایجاد کپی",
      },
      CREATE_EDIT_SCORING_CARD: {
        EDIT_PAGE_TITLE: "ویرایش فرم ارزیابی",
        CREATE_PAGE_TITLE: "ایجاد فرم ارزیابی",
        DESCRIPTION: "توضیحات",
        SCORING_GUID: "راهنمای نمره‌دهی",
        NAME: "نام",
        COMPETENCIES_LIST: "لیست شایستگی‌ها",
        ADD_COMPETENCIES: "افزودن شایستگی",
        EDIT_COMPETENCIES: "افزودن شایستگی",
        COMPETENCY: "شایستگی",
        EDIT: "ویرایش",
        DELETE: "حذف",
        INSERT: "ثبت",
        EMPTY_COMPETENCIES_LIST: "شایستگی برای کارت ثبت نشده است!",
        WEIGHT: "ضریب",
        MINIMUM_WEIGHT_ERROR: "حداقل ضریب ۱ است!",
      },
      RECRUITMENT_REQUEST_FLOW: {
        TITLE: "فرآیند‌های درخواست جذب",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NAME: "نام",
        COPY: "ایجاد کپی",
        EDIT_BTN: "ویرایش",
        DELETE_BTN: "حذف",
        USER: "کاربر ایجاد کننده",
        ADD: "افزودن",
        DELETE_TXT: "آیا از حذف این فرآیند اطمینان دارید؟",
        NO_FLOW: "لیست فرآیند‌ها خالی است",
      },
      MANAGE_FLOW: {
        INSERT_FLOW: "ایجاد فرآیند جدید",
        EDIT_FLOW: "ویرایش فرآیند",
        EDIT_STEP: "ویرایش مرحله",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        NAME: "نام فرآیند",
        INSERT: "ثبت",
        EDIT: "ویرایش",
        ADD_NEW_STEP: "افزودن مرحله جدید",
        STEP_NAME: "نام مرحله",
        STEP_TYPE: "نوع مرحله",
        EMPLOYEES: "اشخاص تأیید کننده",
        MESSAGE_PATTERN: "الگوی پیام",
        DESCRIPTION: "توضیحات",
        INSERT_REQUEST: "ثبت درخواست",
        FLOW_STEPS: "مراحل فرآیند",
        SMS: "پیامک",
        EMAIL: "ایمیل",
        SYSTEM: "یادآوری‌های سامانه",
        NOTIFICATION: "اطلاع رسانی",
        DELETE_TXT: "آیا از حذف این مرحله اطمینان دارید؟",
      },
      RULES_TEMPLATE: {
        TITLE: "الگوهای قوانین مراحل",
        NO_DATA: "لیست الگو‌ها خالی است",
        NAME: "نام",
        COPY: "ایجاد کپی",
        EDIT_BTN: "ویرایش",
        DELETE_BTN: "حذف",
        USER: "کاربر ایجاد کننده",
        ADD: "افزودن",
        DELETE_TEMPLATE_TXT: "آیا از حذف این الگو اطمینان دارید؟",
      },
    },
    REPORT: {
      VISIT: {
        VISIT_RESUME_FORM: "آمار کلی بازدید فرم رزومه",
        VISIT_RESUME_FORM_BY_SOURCE_DATE:
          "آمار بازدید فرم رزومه به تفکیک منابع و تاریخ",
        VISIT_RESUME_FORM_BY_JOBS:
          "آمار بازدید فرم رزومه به تفکیک فرصت‌های شغلی",
        VISIT_RESUME_FORM_BY_SOURCE_JOBS:
          "آمار بازدید فرم رزومه به تفکیک فرصت شغلی و منابع",
        VISIT_RESUME_FORM_BY_LINK_JOB:
          "آمار بازدید فرم رزومه از طریق لینک شناسه دار به تفکیک فرصت شغلی",
        VISIT_RESUME_FORM_BY_LINK:
          "آمار بازدید کنندگان فرم رزومه از طریق لینک های شناسه دار",
        FILTER_BY: "فیلتر بر‌اساس",
        START_DATE: "تاریخ شروع",
        END_DATE: "تاریخ پایان",
        FILTER: "فیلتر",
        JOBS: "فرصت شغلی",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
      },
      JOB_SEEKER: {
        RECEIVED_RESUME_COUNT: "تعداد کل رزومه های دریافتی",
        TOTAL_OF_EMPLOYEE: "تعداد کل استخدامی",
        TOTAL_OF_REJECT: "تعداد کل رزومه های رد شده",
        TOTAL_OF_REVIEW: "تعداد کل رزومه های در حال ارزیابی",
        TOTAL_JOBS: "تعداد کل پیشنهادات شغلی",
        HIRE_TO_OFFER_RATIO: "نسبت استخدامی ها به پیشنهادات",
        AVERAGE_HIRING_TIME: "میانگین زمان استخدام",
        AVERAGE_EJECT_TIME: "میانگین زمان رد",
        REPORT_OF_REJECT_REASON: "گزارش دلایل رد کارجو",
        SEPARATION_OF_RESUMES_PROVINCE: "تفکیک رزومه براساس استان",
        SEPARATION_OF_RESUMES_GENDER: "تفکیک رزومه براساس جنسیت",
        SEPARATION_OF_RESUMES_RESUME_SOURCE:
          "تفکیک رزومه براساس منابع دریافت رزومه",
        SEPARATION_OF_RESUMES_AGE: "تفکیک رزومه براساس سن",
        SEPARATION_OF_RESUMES_DEGREE: "تفکیک رزومه براساس مدرک تحصیلی",
        SEPARATION_OF_RESUMES_JOB_EXPERIENCE: "تفکیک رزومه براساس سابقه شغلی",
        DAY: "روز",
        FILTER_BY: "فیلتر بر‌اساس",
        START_DATE: "تاریخ شروع",
        END_DATE: "تاریخ پایان",
        FILTER: "فیلتر",
        CHART_TYPE: "نوع نمودار",
        ALL: "همه",
        HIRED: "استخدام شده",
        REJECTED: "رد شده",
        DELETE_FILTER: "حذف فیلتر",
        JOBS: "فرصت شغلی",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
      },
      EMPLOYEE: {
        EMPLOYEE_COUNT: "تعداد کل کارمندان شرکت",
        START_DATE: "تاریخ شروع",
        END_DATE: "تاریخ پایان",
        FILTER: "فیلتر",
        DELETE_FILTER: "حذف فیلتر",
        JOBS: "فرصت شغلی",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        SEPARATION_OF_EMPLOYEE_ACTIVITY: "تفکیک کارشناسان براساس فعالیت",
      },
      MESSAGE: {
        EMAIL: "ایمیل",
        SMS: "پیامک",
        SEARCH_RECEIVER: "جستجوی گیرنده",
        UPDATE: "بروزرسانی",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        TIMING: "زمانبندی شده",
        SENT: "ارسال شده",
        PAGE_TITLE: "گزارش پیام‌های ارسال شده",
        NO_EMAIL: "ایمیل ارسال نشده است!",
        NO_SMS: "پیامک ارسال نشده است!",
        SEND_COST: "هزینه ارسال: {cost} ریال",
        PRINT: "چاپ",
      },
    },
    PERSONALITY_TEST: {
      QUESTIONS: {
        ANSWERED: "پاسخ داده شده",
        NO_ANSWERED: "پاسخ داده نشده",
        QUESTION_COUNT: "تعداد کل سوالات",
        INSERT_TEST: "ثبت پاسخ‌ها",
        GENDER_BOX_TITLE: "کارجوی گرامی لطفا به سوال (های) زیر پاسخ دهید",
        GENDER: "جنسیت",
        AGE: "سن",
        FEMALE: "زن",
        MALE: "مرد",
        NAME: "نام",
        EMAIL: "ایمیل",
        MOBILE: "موبایل",
        PERSONAL_INFO: "اطلاعات فردی",
        SHOW_ANSWER: "مشاهده پاسخ",
        TEST_METHOD_TITLE: "نحوه انجام آزمون",
        TEST_FIRST_METHOD: "جواب صحیح و غلط در این آزمون وجود ندارد.",
        TEST_SECOND_METHOD:
          "لطفا به همه سوالات پاسخ دهید و سوالی را بدون جواب نگذارید.",
        TEST_THIRD_METHOD:
          "در پاسخگویی به سوالات صادق بوده و وقت زیادی را صرف یک عبارت نکنید.",
        IMAGE_NUMBER: "تصویر شماره",
      },
      ANSWERS: {
        NEO_SHORT: {
          PAGE_TITLE: "نتیجه آزمون نئو کوتاه (NeoShort)",
          ANSWER: "پاسخ",
          AGREEABLENESS: "توافق پذیری",
          CONSCIENTIOUSNESS: "وظیفه شناسی",
          EXTRA_VERSION: "برون گرایی",
          OPEN_NESS_TO_EXPERIENCE: "گشودگی به تجربه",
          NEUROTICISM: "روان رنجوری",
          SCORE: "امتیاز",
          PRINT: "چاپ",
          SEND_TIME: "زمان پاسخ دهی",
        },
        NEO_LONG: {
          PAGE_TITLE: "نتیجه آزمون نئو فرم بلند (NeoLong)",
          ANSWER: "پاسخ",
          PRINT: "چاپ",
          SEND_TIME: "زمان پاسخ دهی",
        },
        RAVEN: {
          PAGE_TITLE: "نتیجه آزمون ریون(raven)",
          ANSWER: "پاسخ",
          PRINT: "چاپ",
          SEND_TIME: "زمان پاسخ دهی",
          SCORE_TEST: "نمره آزمون",
          AGE: "سن",
          ANSWER_TIME: "مدت زمان پاسخ ",
          SCORE_ANALYSIS: "تحلیل امتیاز",
          PERFORMANCE_ANALYSIS: "تحلیل عملکرد",
          IQ_LEVEL: "سطح هوش",
          CORRECT_ANSWER: "پاسخ صحیح",
          INCORRECT_ANSWER: "پاسخ غلط",
          UNANSWERED: "بدون پاسخ",
          ANSWER_STATUS: "وضعیت پاسخ‌ها",
        },
        MBTI: {
          PAGE_TITLE: "نتیجه آزمون (MBTI)",
          ANSWER: "پاسخ",
          PRINT: "چاپ",
          CHARACTER_TYPE_NAME: "نام تیپ شخصیتی",
          CHARACTER_TYPE_CODE: "کد تیپ شخصیتی",
          SUITABLE_JOBS: "شغل های مناسب",
          DESCRIPTION: "توضیحات",
          SEND_TIME: "زمان پاسخ دهی",
        },
        DISC: {
          PAGE_TITLE: "نتیجه آزمون (DISC)",
          ANSWER: "پاسخ",
          PRINT: "چاپ",
          CHARACTER_TYPE_NAME: "نام تیپ شخصیتی",
          CHARACTER_TYPE_CODE: "کد تیپ شخصیتی",
          DESCRIPTION: "توضیحات",
          SEND_TIME: "زمان پاسخ دهی",
        },
      },
    },
    CUSTOM_TEST: {
      ANSWER: {
        TEST_NAME: "نام آزمون",
        MULTIPLE_CHOICE_QUESTIONS: "سوالات چند گزینه‌ای",
        CORRECTION_QUESTIONS: "سوالات تشریحی",
        SCORE: "نمره",
        MAX_SCORE: "حداکثر نمره",
        SUM_SCORES: "مجموع نمرات",
        NO_ANSWER: "بدون پاسخ",
        CORRECTION_TEST: "تصحیح آزمون",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        SCORE_FIELD_PLACEHOLDER: "نمره را وارد کنید",
        DATE: "انجام تاریخ",
        ANSWER_TIME: "مهلت پاسخ‌دهی",
        SEND_TIME: "زمان پاسخ دهی",
        NO_GRADING: "نمره‌‌دهی نشده",
        CLOSE: "بستن",
        SHOW_MORE: "مشاهده بیشتر",
      },
      ANSWERS: {
        TIME: "ساعت",
        DATE: "تاریخ",
        ANSWER: "پاسخ",
        SHOW_ANSWER: "مشاهده پاسخ",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        PAGE_TITLE: "لیست پاسخ‌های کاربر",
      },
      QUESTIONS: {
        ANSWERED: "پاسخ داده شده",
        ANSWER: "پاسخ",
        NO_ANSWERED: "پاسخ داده نشده",
        QUESTION_COUNT: "تعداد کل سوالات",
        INSERT_TEST: "ثبت پاسخ‌ها",
        PERIOD_TIME: "مدت زمان پاسخگویی",
        DAY: "روز",
        HOURS: "ساعت",
        MINUTES: "دقیقه",
        SECOND: "ثانیه",
        START_TEST: "شروع آزمون",
        TEST_TIME: "زمان آزمون",
        TEST_METHOD_TITLE: "نحوه انجام آزمون",
        TEST_SECOND_METHOD:
          "لطفا به همه سوالات پاسخ دهید و سوالی را بدون جواب نگذارید.",
        TEST_THIRD_METHOD:
          "در پاسخگویی به سوالات صادق بوده و وقت زیادی را صرف یک عبارت نکنید.",
      },
    },
    TASK: {
      INTERVIEWS: {
        PAGE_TITLE: "تقویم مصاحبه",
        NO_DATA: "لیست تاریخ‌ مصاحبه خالی است",
        DATE_AND_TIME: "تاریخ و ساعت",
        ADD_TO_GOOGLE_CALENDAR: "افزودن به تقویم گوگل",
        CANCEL_INTERVIEW: "لغو زمان مصاحبه",
        INTERVIEWEE: "مصاحبه شونده",
        INTERVIEWERS: "مصاحبه کننده‌ها",
        DELETE_MODAL_TXT: "آیا از حذف قرار مصاحبه اطمینان دارید؟",
        NOT_DEFINED: "مشخص نشده",
        FROM_DATE: "از تاریخ",
        TO_DATE: "تا تاریخ",
        HOURS: "ساعت",
        SHOW_RESUME: "نمایش رزومه",
      },
      EMPLOYEE: {
        PAGE_TITLE: "وظایف همکاران",
        NO_DATA: "لیست وظایف خالی است",
        DELETE_MODAL_TXT: "آیا از حذف وظیفه اطمینان دارید؟",
        TASK_TIME: "مهلت انجام",
        TASK_TYPE: "نوع وظیفه",
        DESCRIPTION: "توضیحات",
        INSERT_NOTE: "ثبت یادداشت",
        NOTE_TEXT: "متن یادداشت",
        INSERT: "ثبت",
        NOTES: "یادداشت‌ها",
        STATUS: "وضعیت",
        TASK_DONE_TIME: "تاریخ انجام",
        REVIEW_RESUME: "بررسی رزومه",
        SHOW_RESUME: "نمایش رزومه",
      },
    },
    TICKET: {
      INDEX: {
        PAGE_TITLE: "پشتیبانی",
        CREATE_TICKET: "ایجاد تیکت جدید",
        SUBJECT: "موضوع",
        INSERT: "ثبت",
        DEPARTMENT: "دپارتمان",
        PRIORITY: "اولویت",
        TEXT: "متن پیام",
        TICKET_TEXT_ERROR: "لطفا متن پیام را وارد کنید",
        NO_DATA: "لیست تیکت خالی است",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
      },
      DETAIL: {
        PAGE_TITLE: "جزییات تیکت",
        TEXT: "متن پیام",
        INSERT: "ثبت",
        DEPARTMENT: "دپارتمان",
        SUBJECT: "موضوع",
        MESSAGES: "پیام‌ها",
        TICKET_TEXT_ERROR: "لطفا متن پیام را وارد کنید",
        CLOSE_TICKET: "بستن تیکت",
        OPEN_TICKET: "باز کردن تیکت",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
      },
    },
    FINANCIAL: {
      SALE: {
        CURRENT_STATUS: "وضعیت فعلی شما",
        SOHA_ATS: "سامانه ATS سها",
        CURRENT_PLAN: "طرح فعلی شما",
        PLAN: "طرح",
        VALIDITY_DATE: "تاریخ اعتبار",
        USER_CAPACITY: "ظرفیت کاربر",
        DAY: "روز",
        JOB_COUNT: "تعداد فرصت شغلی",
        PAYMENT: "پرداخت",
        CANCEL: "انصراف",
        TOMAN: "تومان",
        ACTIVATION_PLAN: "فعال‌سازی",
        PAGE_TITLE: "خرید، تمدید اشتراک",
        UNLIMITED: "نامحدود",
        TOTAL_AMOUNT: "مقدار کل",
        TAX: "مالیات برارزش افزوده",
        AMOUNT_PAYABLE: "قابل پرداخت",
        CALCULATE_INVOICE: "صورت حساب",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
        PAYMENT_GATEWAY: "درگاه پرداخت",
        PAYMENT_FAILED: "پرداخت ناموفق بود!",
        MILLION_TOMANS: "میلیون تومان",
        UNLIMITED_NUMBER: "نامحدود",
        PLAN_NAME: "نام طرح",
        USER_COUNT: "تعداد کاربران",
        ACTIVE_JOB_COUNT: "فرصت شغلی همزمان",
        THREE_MOUNTH_PRICE: "قیمت ۳ ماهه",
        PLAN_TIME: "مدت طرح",
        THREE_MOUNTH: "۳ ماهه",
        PLAN_TIMES_IS_ONE_YEAR: "مدت طرح یک سال است.",
        YEAR_PRICE: "قیمت یک ساله",
        YEAR: "یک ساله",
        RETURNED_TO_ACCOUNT:
          "در صورت کسر مبلغ از حساب، حداکثر تا ۷۲ ساعت بعد به حساب مبدا بازگردانده می شود.",
        END_OF_PLAN_MESSAGE:
          "مدت زمان اشتراک جاری شما به پایان رسیده است، برای استفاده از سامانه، لطفا اشتراک خود را تمدید کنید.",
      },
      INVOICE: {
        PAGE_TITLE: "صورتحساب‌ها",
        CREATE_AT: "تاریخ ایجاد",
        AMOUNT_PAYABLE: "قابل پرداخت",
        TOMAN: "تومان",
        TYPE: "نوع",
        NO_DATA: "لیست صورتحساب خالی است!",
        ACCESS_MESSAGE: ACCESS_MESSAGE,
      },
      INVOICE_DETAIL: {
        PAGE_TITLE: "مشخصات صورتحساب‌",
        BEFORE_PLAN: "طرح قبلی",
        NEW_PLAN: "طرح جدید",
        EXPIRE: "انقضا",
        CREATE_AT: "تاریخ صورتحساب",
        INVOICE_DETAIL: "جزئیات صورتحساب",
        UPGRADE_FEE: "هزینه ارتقا",
        RENEVAL_FEE: "هزینه تمدید",
        TOTAL_AMOUNT: "قیمت طرح",
        TAX: "مالیات برارزش افزوده",
        AMOUNT_PAYABLE: "مبلغ کل",
        DISCOUNT: "تخفیف",
        RIAL: "ریال",
        PAYMENT_GATEWAY: "درگاه پرداخت",
        TO_DATE: "تا تاریخ",
        JOB_COUNT: "تعداد فرصت شغلی",
        JOB: "فرصت شغلی",
        PUBLISH_IN: "منتشر شده در",
        CREATOR: "ایجاد کننده",
        PAYMENT_SUCCESS: "پرداخت موفقیت آمیز بود.",
      },
      WALLET_CHARGE: {
        PAGE_TITLE: "شارژ کیف پول پیامک",
        CHARGE_DESCRIPTION:
          "مبلغ مورد نظر شما پس از اضافه شدن ۱۰ درصد مالیات بر ارزش افزوده به حساب کیف پول پیامک شما اضافه می‌گردد.",
        AMOUNT: "مبلغ شارژ",
        PAYMENT: "پرداخت",
        VAT: "مالیات بر ارزش افزوده",
        AMOUNT_PAY: "مبلغ قابل پرداخت",
        RIAL: "ریال",
        NO_VALID_AMOUNT: "مبلغ وارد شده معتبر نمی باشد",
        PAYMENT_FAILED: "پرداخت ناموفق بود!",
        RETURNED_TO_ACCOUNT:
          "در صورت کسر مبلغ از حساب، حداکثر تا ۷۲ ساعت بعد به حساب مبدا بازگردانده می شود.",
        PAYMENT_GATEWAY: "درگاه پرداخت",
      },
    },
    ERROR: {
      ERROR: {
        SORRY: "متاسفیم",
        DESCRIPTION:
          "صفحه‌ای که قصد ورود به آن را دارید وجود ندارد یا حذف شده است.",
        DASHBOARD: "ورود به صفحه اصلی",
      },
      ERROR_503: {
        SORRY: "متاسفیم",
        DESCRIPTION:
          "برای ارائه خدمات بهتر، سامانه در حال بروزرسانی می‌باشد. </br>لطفاً دقایقی بعد دوباره تلاش فرمایید</br> از شکیبایی شما سپاسگزاریم.",
        DASHBOARD: "ورود به صفحه اصلی",
      },
    },
  },
  JOB_SEEKER: {
    COMPONENTS: {
      AUTH: {
        REGISTER: {
          MOBILE: "شماره موبایل",
          REGISTER: "ثبت نام",
          CODE: "کد اعتبارسنجی",
          SEND_CODE: "ارسال کد",
          FIRST_NAME: "نام",
          LAST_NAME: "نام خانوادگی",
          EMAIL: "ایمیل",
          GENDER: "جنسیت",
          BIRTH_DATE: "تاریخ تولد",
          PASSWORD_PLACEHOLDER: "کلمه عبور",
          REPEATE_PASSWORD_PLACEHOLDER: "تکرار کلمه عبور",
          NO_EDUCATIONAL: "مدرک تحصیلی ندارم",
          NO_JOB: " سابقه کار ندارم",
          NO_SKILL: "مهارت ندارم",
          JOB_TITLE: "عنوان شغل",
          START_DATE: "تاریخ شروع",
          END_DATE: "تاریخ پایان",
          COMPANY_NAME: "نام محل کار",
          MAJOR: "رشته تحصیلی",
          DEGREE: "مقطع تحصیلی",
          UNIVERSITY: "نام دانشگاه",
          SKILL_TITLE: "عنوان مهارت",
          LEVEL: "سطح تسلط",
          INSERT: "ثبت اطلاعات",
          ADD_SKILL: "افزودن مهارت",
          BACK: "بازگشت",
          IS_EMPLOYED: "مشغول به کار هستم",
          CONTINUE: "ادامه",
          WRONG_REPEAT_PASSWORD_ERR: "تکرار کلمه عبور صحیح نمی باشد",
          TO_NUMBER: "به شماره ",
          SENT: "ارسال شد",
          CHANGE_NUMBER: "تغییر شماره",
          RESEND_CODE: "ارسال مجدد",
          UP_TO: " تا",
          RESUME_CONFIRM: "تایید رزومه",
          YES: "بلی",
          NO: "خیر",
          CONFIRM_MODAL_MESSAGE:
            " با توجه به این که شما قبلاً به شرکت‌های عضو سامانه هوشمند استخدام سها درخواست استخدام داده‌اید، نسخه‌ای از رزومه شما در سامانه موجود است. آیا مایلید اطلاعات رزومه قبلی در پروفایل شما جایگذاری شود؟ <br> پس از جایگذاری امکان ویرایش اطلاعات را خواهید داشت.",
        },
      },
      JOB: {
        JOB_FILTER: {
          ADVANCED_SEARCH: "جستجوی پیشرفته",
          JOB_TITLE: "عنوان فرصت شغلی",
          COMPANY_NAME: "نام شرکت",
          ADDRESS: "استان و شهر",
          JOB_CATEGORY: "دسته بندی شغلی",
          TYPE_COOPERATION: "نوع همکاری",
          MINIMUM_SALARY: "حداقل حقوق",
          WORK_EXPERIENCE: "سابقه کار مرتبط",
          MINIMUM_DEGREE: "حداقل مدرک مورد نیاز",
          GENDER: "جنسیت",
          MILITARY_SERVICE: "وضعیت خدمت سربازی",
          REMOVE_FILTER: "حذف فیلتر",
        },
        JOB_HEADER: {
          LOGIN_REGISTER: "ورود / ثبت نام",
          EMPLOYER_PANEL: "ورود به بخش کارفرمایان",
          JOBSEEKER_PANEL: "ورود/ثبت نام کارجویان",
          LOGOUT: "خروج از حساب کاربری",
          MY_RESUME: "رزومه من",
        },
        JOBS: {
          FILTERS: "فیلترها",
          IS_EMPLOYER: "کارفرما هستید؟",
          INSERT_JOB: "آگهی خود را ثبت کنید",
          PAGE_TITLE: "جستجوی آگهی‌های استخدام",
          NO_JOB: "آگهی وجود ندارد.",
          NO_MORE_JOB: "آگهی بیشتری وجود ندارد.",
          APPLY_FILTERS: "اعمال فیلترها",
        },
      },
      HISTORY: {
        HISTORY_CARD: {
          SEND_IN: "ارسال شده در",
          SEEN: "کارفرما رزومه شما را دیده است",
          UNSEEN: "کارفرما هنوز رزومه شما را ندیده است",
        },
      },
    },
    PAGES: {
      AUTH: {
        LOGIN: {
          PAGE_TITLE: "ورود کارجویان",
          LOGIN_BTN_TEXT: "ورود",
          REGISTER_BTN_TEXT: "ثبت نام",
          FORGOT_PASSWORD_TEXT: "کلمه عبورم را فراموش کرده‌ام!",
          USERNAME_PLACEHOLDER: "شماره موبایل یا آدرس ایمیل",
          PASSWORD_PLACEHOLDER: "کلمه عبور",
          WRONG_USERNAME_OR_PASSWORD_ERR: "نام کاربری یا کلمه عبور اشتباه است!",
          LOGIN_FROM_INVITATION_MESSAGE: "برای تایید عضویت، باید وارد شوید.",
          OTHER_USER_DESCRIPTION:
            "شما با حساب کاربری {name} با شماره موبایل {mobile} وارد شده‌اید. آیا تایید می کنید که اطلاعات رزومه شما به سایت {website} ارسال شود؟",
          CONFIRM_CONTINUE: "تایید و ادامه",
          CANCEL_RETURN: "انصراف و بازگشت",
          LOGIN_ANOTHER_ACCOUNT: "ورود با حساب کاربری دیگر",
          FORGET_PASSWORD: "کلمه عبورم را فراموش کرده‌ام!",
          IS_EMPLOYER: "کارفرما هستید؟",
          EMPLOYER_LOGIN: "ورود به بخش کارفرمایان",
        },
        REGISTER: {
          PAGE_TITLE: "فرم ثبت‌نام کارجو",
          MOBILE_PLACEHOLDER: "موبایل",
          PASSWORD_PLACEHOLDER: "کلمه عبور",
          REPEAT_PASSWORD_PLACEHOLDER: "تکرار کلمه عبور",
          REGISTER: "ثبت‌نام",
          WRONG_REPEAT_PASSWORD_ERR: "تکرار کلمه عبور صحیح نمی باشد",
          CODE: "کد اعتبارسنجی",
        },
        FORGET_PASSWORD: {
          PAGE_TITLE: "بازیابی کلمه عبور",
          USERNAME_PLACEHOLDER: "شماره موبایل",
          SEND_SMS_TEXT_PART_ONE: "کد تایید از طریق پیامک به شماره",
          SEND_SMS_TEXT_PART_TWO: "ارسال شد.",
          USERNAME: "نام کاربری",
          RESEND: "ارسال مجدد",
          SEND: "ارسال",
          CONTINUE: "ادامه",
          CODE: "کد اعتبارسنجی",
          SERVER_ERROR:
            "در زمان ارتباط با سرور خطایی پیش آمد. لطفا دوباره امتحان کنید یا با پشتیبانی تماس بگیرید.",
          RESTART_RESET_PASSWORD_ERROR:
            "به نظر می‌رسد خطایی به وجود آمده است. لطفا فرایند بازیابی را دوباره شروع کنید.",
          WRONG_CODE: "کد اعتبارسنجی صحیح نیست.",
          WRONG_USERNAME: "کلمه عبور اشتباه است.",
        },
        RESET_PASSWORD: {
          PASSWORD: "کلمه عبور",
          PASSWORD_REPEAT: "تکرار کلمه عبور",
          CHANGE_PASSWORD: "تغییر کلمه عبور",
          REPEAT_PASS_ERROR: "تکرار رمز را به صورت صحیح وارد کنید",
          EMPTY_REPEAT_PASS: "لطفا تکرار رمز را وارد کنید",
        },
      },
      JOB: {
        JOB: {
          LOGIN_REGISTER: "ورود / ثبت نام",
          EMPLOYER_PANEL: "بخش کارفرمایان",
        },
        DETAIL: {
          TITLE: "استخدام {title} در {company}",
          IN: "در",
          SEND_RESUME: "ارسال رزومه",
          SENT_RESUME: "قبلا برای این موقعیت شغلی رزومه ارسال کرده‌اید",
          EMPLOYMENT: "استخدام",
          JOB_CATEGORY: "دسته‌بندی شغلی",
          COOPERATION_TYPE: "نوع همکاری",
          CITY: "استان و شهر",
          CAUSE: "علت درخواست جذب نیرو",
          MINIMUM_SALARY: "حداقل حقوق",
          WORK_EXPERIENCE: "سابقه کار",
          MINIMUM_DEGREE: "حداقل مدرک تحصیلی",
          GENDER: "جنسیت",
          MILITARY_SERVICE: "وضعیت خدمت سربازی",
          JOB_ACTIVITY: "شرح آگهی استخدام",
          JOB_SUB_CATEGORY: "زیرگروه شغلی",
          ADDRESS: "محدوده محل کار",
          IS_EMPLOYER: "کارفرما هستید؟",
          INSERT_JOB: "آگهی خود را ثبت کنید",
          EMPLOYER_PANEL: "بخش کارفرمایان",
          JOB: "عنوان شغلی",
          MY_RESUME: "رزومه من",
          COMPLETE_RESUME: "تکمیل رزومه",
          COMPLETE_FORM: "تکمیل فرم استخدام",
          COMPLETE: "تکمیل شده",
          LOGIN: "ورود",
          DESCRITION: "توضیحات (اختیاری)",
          DESCRITION_GUID: "متن زیر مستقیما برای کارفرما ارسال می شود.",
          MOBILE: "شماره موبایل",
          FORGOT_PASSWORD: "کلمه عبورم را فراموش کرده‌ام!",
          REGISTER: "ثبت نام",
          PASSWORD_PLACEHOLDER: "کلمه عبور",
          WRONG_USERNAME_OR_PASSWORD_ERR: "نام کاربری یا کلمه عبور اشتباه است!",
          WRONG_REPEAT_PASSWORD_ERR: "تکرار کلمه عبور صحیح نمی باشد",
          REQUIRED_FILEDS_DESCRITION:
            "برخی از اطلاعاتی که باید در فرم استخدامی شرکت «{companyName}» ثبت شود، در رزومه‌ی ذخیره‌شده شما وجود ندارد، لطفا ابتدا با وارد کردن این اطلاعات فرم استخدام را کامل کنید.",
          RELATED_JOBS: "آگهی‌های استخدام مشابه",
          CONTINUE: "ادامه",
          COMPLETE_RESUME_DESCRIPTION:
            "رزومه‌های کامل‌تر از ۷۰% شانس بیشتری برای استخدام شدن دارند.",
          LOGIN_WITH_CODE: "ورود با پیامک",
          RESEND: "ارسال مجدد",
          UP_TO: " تا",
          LOGIN_CODE: "رمز یکبار مصرف",
        },
        PREFERENCES: {
          PAGE_TITLE: "اطلاع‌رسانی آگهی",
          ADD_PROVINCE: "افزودن استان",
          ADD_JOB_GROUP: "افزودن گروه شغلی",
          JOB_GROUP: "گروه شغلی",
          INTERVAL_POSTING_DATE: "بازه زمانی ارسال آگهی",
          DAILY: "روزانه",
          TWO_DAY: "دوروز یکبار",
          THREE_DAY: "سه روز یکبار",
          WEEKLY: "هفتگی",
        },
      },
      RESUME: {
        RESUME: {
          SEND_RESUME_DESCRIPTION:
            "رزومه خود را برای آگهی «{jobTitle}» در شرکت  «{companyName}» ارسال کنید",
          SEND_RESUME: "ارسال رزومه",
          CLOSE: "بستن",
          MODAL_MESSAGE:
            "اطلاعات پروفایل شما با موفقیت جایگذاری شد. لطفاً رزومه ذخیره‌شده خود را بررسی کرده و در صورت لزوم آن را اصلاح و بروزرسانی کنید.",
        },
      },
      REQUEST_HISTORY: {
        REQUEST_HISTORY: {
          PAGE_TITLE: "رزومه‌های ارسال شده",
          SEEN: "دیده شده",
          UNSEEN: "دیده نشده",
          ALL: "همه",
        },
      },
    },
  },
};
